// PeptideVault v6.5 — All modal dialogs
import { renderPickedProtocolVials, protocolVialAssignmentSummary } from '../services/protocol-vial-history.js'

// ══════════════════════════════════════════════════════
// RENDER: MODALS
// ══════════════════════════════════════════════════════
function labMarkerRow(m, i) {
  return `<div style="display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:4px">
    <input class="form-input" id="lm-name-${i}" placeholder="Marker" value="${esc(m?.name||'')}" style="font-size:12px;padding:6px">
    <input class="form-input" id="lm-val-${i}" placeholder="Value" value="${esc(m?.value||'')}" style="font-size:12px;padding:6px">
    <input class="form-input" id="lm-unit-${i}" placeholder="Unit" value="${esc(m?.unit||'')}" style="font-size:12px;padding:6px">
    <input class="form-input" id="lm-lo-${i}" placeholder="Low" value="${esc(m?.refLow||'')}" style="font-size:12px;padding:6px">
    <input class="form-input" id="lm-hi-${i}" placeholder="High" value="${esc(m?.refHigh||'')}" style="font-size:12px;padding:6px">
    <button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="this.closest('div').remove()">✕</button>
  </div>`
}

function addLabMarkerRow() {
  const container = document.getElementById('lab-marker-rows')
  if (!container) return
  const idx = container.children.length
  const row = document.createElement('div')
  row.innerHTML = labMarkerRow({}, idx)
  container.appendChild(row.firstElementChild)
}

function modalDateLabel(date) {
  if (!date) return 'Date not set'
  try { return new Date(date + 'T12:00:00').toLocaleDateString(undefined,{month:'short',day:'numeric',year:'numeric'}) }
  catch(e) { return date }
}

function renderModal() {
  if (!S.modal) return ''
  const d = S.modalData || {}
  let content = ''

  if (S.modal === 'addPeptide' || S.modal === 'editPeptide') {
    const isEdit = S.modal === 'editPeptide'
    const p = isEdit ? getPeptide(d.pid) : null
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${isEdit ? 'Edit Peptide' : 'Add Peptide'}</h3>
        <button class="btn-icon" aria-label="Close" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        <div class="form-row form-row-2">
          <div class="form-group" style="grid-column:1/-1">
            <label class="form-label">Peptide Name *</label>
            <input class="form-input" id="f-name" placeholder="e.g. BPC-157" value="${esc(p?.name||'')}">
          </div>
          <div class="form-group" style="grid-column:1/-1">
            <label class="form-label">Custom Vial Name <span style="font-weight:400;color:var(--text4)">(optional display name)</span></label>
            <input class="form-input" id="f-vial-name" placeholder="e.g. Tissue Repair Complex" value="${esc(p?.customVialName||'')}">
          </div>
          <div class="form-group" style="grid-column:1/-1">
            <label class="form-label">Categories <span style="font-weight:400;color:var(--text4)">(Cmd/Ctrl+click to select multiple)</span></label>
            <select class="form-input form-select" id="f-pep-cats" multiple style="height:96px">
              ${getAllCategories().map(c => `<option value="${esc(c.label)}" ${(p?.categories||[]).includes(c.label)?'selected':''}>${esc(c.label)}</option>`).join('')}
            </select>
            <div style="display:flex;gap:8px;margin-top:8px">
              <input class="form-input" id="f-pep-newcat" placeholder="Create a new category…" style="flex:1" onkeydown="if(event.key==='Enter'){event.preventDefault();createCategoryFromPeptideModal()}">
              <button type="button" class="btn btn-secondary btn-sm" onclick="createCategoryFromPeptideModal()">${ICONS.plus} Create &amp; Select</button>
            </div>
          </div>
        </div>
        <div class="form-row form-row-3">
          <div class="form-group">
            <label class="form-label">Quantity Unit</label>
            <select class="form-input form-select" id="f-unit">
              ${['vials','mcg','mg','IU','nmol','units'].map(u=>`<option ${(p?.unit||'vials')===u?'selected':''}>${u}</option>`).join('')}
            </select>
          </div>
        </div>
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Low Stock Alert Threshold <span style="font-weight:400;color:var(--text4)">(0 = disabled)</span></label>
            <input class="form-input" id="f-thresh" type="number" min="0" placeholder="0" value="${esc(p?.lowStockThreshold||'0')}">
          </div>
          <div class="form-group">
            <label class="form-label">Pep-Pedia URL</label>
            <input class="form-input" id="f-peppedia" placeholder="https://pep-pedia.org/bpc-157" value="${esc(p?.pepPediaUrl||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Half-Life (hours) <span style="font-weight:400;color:var(--text4)">e.g. 4 for BPC-157, 72 for TB-500</span></label>
            <input class="form-input" id="f-halflife" type="number" step="any" min="0" placeholder="e.g. 4" value="${esc(p?.halfLife||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">SubQ Absorption Rate — ka (hr⁻¹) <span style="font-weight:400;color:var(--text4)">default 0.8, range 0.3–2.0</span></label>
            <input class="form-input" id="f-ka" type="number" step="0.1" min="0.1" max="5" placeholder="0.8" value="${esc(p?.absorptionRate||'0.8')}">
          </div>
        </div>
        <!-- Blend definition at peptide level -->
        <div class="form-group">
          <div class="toggle-wrap" onclick="togglePepBlend()">
            <div class="toggle ${p?.isBlend?'on':''}" id="pep-blend-toggle"></div>
            <span class="form-label" style="margin:0">This is a Blend</span>
          </div>
        </div>
        <div id="pep-blend-section" style="display:${p?.isBlend?'block':'none'}">
          <div class="form-group">
            <label class="form-label">Blend Components <span style="font-weight:400;color:var(--text4)">— name, half-life (h), and absorption rate (ka) per component</span></label>
            <div style="display:grid;grid-template-columns:2fr 1fr 1fr auto;gap:4px;margin-bottom:4px;padding:0 2px">
              <span style="font-size:10px;font-weight:700;color:var(--text4)">Peptide</span>
              <span style="font-size:10px;font-weight:700;color:var(--text4)">t½ (hours)</span>
              <span style="font-size:10px;font-weight:700;color:var(--text4)">ka (/hr)</span>
              <span></span>
            </div>
            <div id="pep-blend-rows" style="display:flex;flex-direction:column;gap:6px">
              ${(p?.blendComponents?.length ? p.blendComponents : [{peptideName:'',peptideId:'',halfLife:'',absorptionRate:''}]).map((c,i) => `
              <div style="display:grid;grid-template-columns:2fr 1fr 1fr auto;gap:4px;align-items:center" class="pep-blend-row" data-idx="${i}">
                <div>
                  <select class="form-input form-select" id="f-pep-blend-${i}" onchange="onPepBlendSelectChange(this)">
                    <option value="">— Select Peptide —</option>
                    ${S.peptides.filter(x=>!x.isBlend||x.id===(p?.id||'')).map(x=>`<option value="${x.id}" ${c.peptideId===x.id||c.peptideName===x.name?'selected':''}>${esc(x.name)}</option>`).join('')}
                    <option value="__custom__" ${!S.peptides.find(x=>x.id===c.peptideId||x.name===c.peptideName)&&c.peptideName?'selected':''}>Custom name…</option>
                  </select>
                  <input class="form-input" id="f-pep-blend-name-${i}" placeholder="Type peptide name" value="${esc(c.peptideName||'')}" style="display:${!S.peptides.find(x=>x.id===c.peptideId||x.name===c.peptideName)&&c.peptideName?'block':'none'};margin-top:4px">
                </div>
                <input class="form-input" id="f-pep-blend-hl-${i}" type="number" step="any" min="0" placeholder="e.g. 4" value="${esc(c.halfLife||'')}" title="Half-life in hours">
                <input class="form-input" id="f-pep-blend-ka-${i}" type="number" step="0.1" min="0.1" placeholder="0.8" value="${esc(c.absorptionRate||'')}" title="Absorption rate ka (default 0.8)">
                <button class="btn-icon" onclick="removePepBlendRow(${i})">${ICONS.trash}</button>
              </div>`).join('')}
            </div>
            <button class="btn btn-secondary btn-sm" style="margin-top:8px" onclick="addPepBlendRow()">${ICONS.plus} Add Component</button>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Notes</label>
          <textarea class="form-input" id="f-notes" rows="2" placeholder="General notes…">${esc(p?.notes||'')}</textarea>
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditPeptide('${d.pid}')` : 'saveAddPeptide()'}">${isEdit ? 'Save Changes' : 'Add Peptide'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'addSku' || S.modal === 'editSku') {
    const isEdit = S.modal === 'editSku'
    const s = isEdit ? getSku(d.pid, d.sid) : null
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${isEdit ? 'Edit SKU' : 'Add SKU / Lot'}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Barcode</label>
            <input class="form-input mono" id="f-barcode" placeholder="Scan or type barcode" value="${esc(s?.barcode||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Vendor / Source</label>
            <input class="form-input" id="f-vendor" placeholder="Vendor name" value="${esc(s?.vendor||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Lot Number</label>
            <input class="form-input" id="f-lot" placeholder="LOT-001" value="${esc(s?.lotNumber||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Cap Color</label>
            <input class="form-input" id="f-capcolor" placeholder="e.g. Blue, Red, White/Silver" value="${esc(s?.capColor||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Purity</label>
            <input class="form-input" id="f-purity" placeholder="99.2%" value="${esc(s?.purity||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Vial Strength <span style="font-weight:400;color:var(--text4)">labeled strength used for inventory planning</span></label>
            <div style="display:grid;grid-template-columns:minmax(0,1fr) 110px;gap:8px">
              <input class="form-input" id="f-vial-strength" type="number" step="any" min="0" placeholder="e.g. 40" value="${esc(s?.vialStrength ?? s?.vialStrengthMg ?? s?.mgPerVial ?? '')}">
              <select class="form-input" id="f-vial-strength-unit">
                ${['mcg','mg','IU'].map(unit => `<option value="${unit}" ${(s?.vialStrengthUnit || 'mg')===unit?'selected':''}>${unit}</option>`).join('')}
              </select>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Tested Concentration <span style="font-weight:400;color:var(--text4)">from COA</span></label>
            <input class="form-input" id="f-conc" placeholder="e.g. 41.2 mg/vial" value="${esc(s?.testedConcentration||s?.concentration||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Expiry Date</label>
            <input class="form-input" id="f-exp" type="date" value="${s?.expiryDate||''}">
          </div>
          <div class="form-group">
            <label class="form-label">Cost Per Vial ($)</label>
            <input class="form-input" id="f-cost" type="number" step="0.01" min="0" placeholder="0.00" value="${esc(s?.costPerVial||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Doses Per Vial <span style="font-weight:400;color:var(--text4)">for cost/injection calc</span></label>
            <input class="form-input" id="f-doses" type="number" step="1" min="1" placeholder="e.g. 10" value="${esc(s?.dosesPerVial||'')}">
          </div>
          <div class="form-row form-row-2">
            <div class="form-group">
              <label class="form-label">NIIMBOT Label</label>
              <input class="form-input mono" id="f-niimlabel" placeholder="⊙abc123⊙" value="${esc(s?.niimLabel||'')}">
            </div>
            <div class="form-group">
              <label class="form-label">NIIMBOT QR</label>
              <input class="form-input mono" id="f-niimqr" placeholder="⊙def456⊙" value="${esc(s?.niimQR||'')}">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="toggle-wrap" onclick="toggleBlend()">
            <div class="toggle ${(s?.isBlend||S.modalData._blend)?'on':''}" id="blend-toggle"></div>
            <span style="font-size:13px;font-weight:600">Blend</span>
            <span style="font-size:12px;color:var(--text3)">— check if this vial contains multiple peptides</span>
          </div>
        </div>
        <div id="blend-section" style="display:${(s?.isBlend||S.modalData._blend)?'block':'none'}">
          <div style="background:var(--purpleL);border-radius:var(--r2);padding:14px;display:flex;flex-direction:column;gap:8px">
            <div style="font-size:12px;font-weight:700;color:var(--purpleT)">BLEND COMPONENTS</div>
            <div id="blend-rows">
              ${(s?.blendComponents||S.modalData._comps||[{peptide:'',vialStrength:''}]).map((c,i)=>`
              <div class="form-row form-row-2" data-blend-row="${i}">
                <div class="form-group"><label class="form-label">Peptide</label><input class="form-input" id="bc-pep-${i}" value="${esc(c.peptide)}"></div>
                <div class="form-group"><label class="form-label">Vial Strength</label><input class="form-input" id="bc-str-${i}" value="${esc(c.vialStrength)}"></div>
              </div>`).join('')}
            </div>
            <button class="btn btn-secondary btn-sm" style="width:fit-content" onclick="addBlendRow()">+ Add Component</button>
          </div>
        </div>
        ${!isEdit ? `
        <div class="form-group">
          <label class="form-label">Initial Quantity (vials)</label>
          <input class="form-input" id="f-qty" type="number" min="0" placeholder="0" value="0">
        </div>` : ''}
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" id="sku-save-btn">${isEdit ? 'Save SKU' : 'Add SKU'}</button>
      </div>
    </div>`
    // Attach the onclick after render to avoid nested-template-literal quoting issues
    setTimeout(() => {
      const btn = document.getElementById('sku-save-btn')
      if (btn) btn.onclick = isEdit
        ? () => saveEditSku(d.pid, d.sid)
        : () => saveAddSku(d.pid)
    }, 0)
  }

  else if (S.modal === 'addDoc' || S.modal === 'editDoc') {
    const isEdit = S.modal === 'editDoc'
    const doc = isEdit ? getDoc(d.docId) : null
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>${isEdit ? 'Edit Document' : 'Add Document(s)'}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        ${!isEdit ? `
        <div class="form-group">
          <label class="form-label">Name <span style="font-weight:400;color:var(--text4)">(optional — used only for a single file; multiple files are named from their filenames)</span></label>
          <input class="form-input" id="f-docname" placeholder="Leave blank to use the filename">
        </div>` : `
        <div class="form-group">
          <label class="form-label">Document Name *</label>
          <input class="form-input" id="f-docname" placeholder="e.g. BPC-157 COA Lot001" value="${esc(doc?.name||'')}">
        </div>`}
        <div class="form-group">
          <label class="form-label">Type / Category ${!isEdit ? '<span style="font-weight:400;color:var(--text4)">(applies to every file you select)</span>' : ''}</label>
          <select class="form-input form-select" id="f-doctype">
            ${[['protocol','Protocol'],['health','Health Information'],['research','Research'],['other','Other']].map(([v,l])=>`<option value="${v}" ${(doc?.type||'other')===v?'selected':''}>${l}</option>`).join('')}
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">Notes ${!isEdit ? '<span style="font-weight:400;color:var(--text4)">(applies to all)</span>' : ''}</label>
          <textarea class="form-input" id="f-docnotes" rows="2" placeholder="Optional notes…">${esc(doc?.notes||'')}</textarea>
        </div>
        ${!isEdit ? `
        <div style="background:var(--blueL);border-radius:var(--r2);padding:14px;font-size:13px;color:var(--blue2)">
          📂 After clicking below, a file picker opens. <strong>Select one or many files</strong> (Shift-click or Cmd-click to pick multiple) — the Type and Notes above will apply to all of them.
        </div>` : ''}
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditDoc('${d.docId}')` : 'saveAddDoc()'}">${isEdit ? 'Save Changes' : 'Select File(s) & Add'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'addDosage' || S.modal === 'editDosage') {
    const isEdit = S.modal === 'editDosage'
    const dp = isEdit ? getPeptide(d.pid)?.dosageProtocols?.find(x=>x.id===d.dpid) : null
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${isEdit ? 'Edit Dosage Protocol' : 'Add Dosage Protocol'}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">Protocol Name *</label>
          <input class="form-input" id="f-dpname" placeholder="e.g. Healing Protocol" value="${esc(dp?.name||'')}">
        </div>
        <div class="form-row form-row-3">
          <div class="form-group">
            <label class="form-label">Dose</label>
            <input class="form-input" id="f-dpdose" type="number" step="any" min="0" placeholder="250" value="${esc(dp?.dose||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Unit</label>
            <select class="form-input form-select" id="f-dpunit">
              <option value="mcg" ${dp?.doseUnit==='mcg'?'selected':''}>mcg</option>
              <option value="mg" ${dp?.doseUnit==='mg'?'selected':''}>mg</option>
              <option value="mL" ${dp?.doseUnit==='mL'?'selected':''}>mL</option>
              <option value="IU" ${dp?.doseUnit==='IU'?'selected':''}>IU</option>
              <option value="units" ${dp?.doseUnit==='units'?'selected':''}>units</option>
              <option value="sprays" ${dp?.doseUnit==='sprays'?'selected':''}>sprays</option>
              <option value="drops" ${dp?.doseUnit==='drops'?'selected':''}>drops</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Route</label>
            <select class="form-input form-select" id="f-dproute">
              ${['SubQ','IM','Oral','Nasal','Topical'].map(r=>`<option ${dp?.route===r?'selected':''}>${r}</option>`).join('')}
            </select>
          </div>
        </div>
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Frequency</label>
            <select class="form-input form-select" id="f-dpfreq">
              ${[['daily','Daily'],['twice_daily','Twice Daily'],['eod','Every Other Day'],['three_week','3x / Week'],['weekly','Weekly'],['biweekly','Biweekly']].map(([v,l])=>`<option value="${v}" ${dp?.frequency===v?'selected':''}>${l}</option>`).join('')}
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Duration</label>
            <input class="form-input" id="f-dpdur" placeholder="e.g. 12 weeks" value="${esc(dp?.duration||'')}">
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Status</label>
          <select class="form-input form-select" id="f-dpstatus">
            <option value="planned" ${dp?.status==='planned'?'selected':''}>Planned</option>
            <option value="active" ${dp?.status==='active'?'selected':''}${!dp?'selected':''}>Active</option>
            <option value="past" ${dp?.status==='past'?'selected':''}>Past</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">Notes</label>
          <textarea class="form-input" id="f-dpnotes" rows="2" placeholder="Additional notes…">${esc(dp?.notes||'')}</textarea>
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditDosage('${d.pid}','${d.dpid}')` : `saveAddDosage('${d.pid}')`}">Save</button>
      </div>
    </div>`
  }

  else if (S.modal === 'linkProtocol') {
    const p = getPeptide(d.pid)
    const protocolDocs = S.documents.filter(doc => doc.type === 'protocol')
    const linked = p?.protocolDocIds || []
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>Link Protocol Document</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        ${protocolDocs.length === 0 ? `
        <div class="empty-state" style="padding:24px">
          <div class="empty-icon">📄</div>
          <p>No Protocol documents in library</p>
          <span>Add Protocol documents in the Document Library first</span>
        </div>` : `
        <div style="font-size:13px;color:var(--text2);margin-bottom:12px">Select Protocol documents to link to <strong>${esc(p?.name)}</strong>:</div>
        <div style="display:flex;flex-direction:column;gap:8px">
          ${protocolDocs.map(doc => {
            const isLinked = linked.includes(doc.id)
            return `
            <div class="row" style="background:var(--bg3);border:1px solid ${isLinked?'var(--blue)':'var(--border)'};border-radius:var(--r2);padding:10px 14px">
              <span class="doc-type-badge ${docTypeClass(doc.type)}" style="flex-shrink:0">${docTypeName(doc.type)}</span>
              <span style="flex:1;font-size:13px;font-weight:500;margin:0 10px">${esc(doc.name)}</span>
              ${isLinked
                ? `<button class="btn btn-danger btn-xs" onclick="unlinkProtocolDoc('${d.pid}','${doc.id}')">${ICONS.unlink} Unlink</button>`
                : `<button class="btn btn-success btn-xs" onclick="linkProtocolDoc('${d.pid}','${doc.id}')">${ICONS.link} Link</button>`
              }
            </div>`}).join('')}
        </div>`}
      </div>
      <div class="modal-ftr">
        <button class="btn btn-primary" onclick="closeModal()">Done</button>
      </div>
    </div>`
  }

  else if (S.modal === 'monthDetail') {
    const { label, injs } = d
    // Group by date
    const byDate = {}
    injs.forEach(i => { if (!byDate[i.date]) byDate[i.date] = []; byDate[i.date].push(i) })
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${esc(label)} — ${injs.length} injection${injs.length!==1?'s':''}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="max-height:70vh;overflow-y:auto;gap:0;padding:0">
        ${Object.entries(byDate).map(([date, dayInjs]) => `
        <div style="border-bottom:1px solid var(--border);padding:10px 16px">
          <div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:6px">${new Date(date+'T12:00:00').toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'})}</div>
          ${dayInjs.map(inj => `
          <div style="display:flex;align-items:center;gap:10px;padding:4px 0">
            <div style="width:8px;height:8px;border-radius:50%;background:${peptideColor(inj.peptideName)};flex-shrink:0"></div>
            <span style="font-size:13px;font-weight:600;color:${peptideColor(inj.peptideName)};min-width:120px">${esc(inj.peptideName)}</span>
            ${inj.time ? `<span class="badge badge-gray" style="font-size:11px">${fmt12(inj.time)}</span>` : ''}
            ${inj.dosage ? `<span style="font-size:12px;color:var(--text2)">${esc(inj.dosage)}</span>` : ''}
            ${inj.drawUnits ? `<span style="font-size:12px;color:var(--text3)">Draw: ${esc(inj.drawUnits)}</span>` : ''}
          </div>`).join('')}
        </div>`).join('')}
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="exportMonthCSV('${d.monthKey}')">${ICONS.export} Export Month CSV</button>
        <button class="btn btn-primary" onclick="closeModal()">Done</button>
      </div>
    </div>`
  }

  else if (S.modal === 'assignInjections') {
    const unassigned = S.injections.filter(i => !i.userId)
    const activeUsers = (S.users||[]).filter(u=>u.active)
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>Assign Injections to a Person</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          You have <strong>${unassigned.length}</strong> injection${unassigned.length!==1?'s':''} not yet assigned to anyone (e.g. imported before user tracking). Pick who they belong to — this assigns all unassigned injections at once.
        </div>
        <div class="form-group">
          <label class="form-label">Assign all unassigned to</label>
          <select class="form-input form-select" id="assign-user-select">
            ${activeUsers.map(u => `<option value="${u.id}">${esc(u.name)}</option>`).join('')}
          </select>
        </div>
        <div style="font-size:12px;color:var(--text4)">Already-assigned injections won't be touched. You can re-assign individual ones later by editing them.</div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="assignUnassignedInjections()">Assign ${unassigned.length}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'dayDetail') {
    const { label, injs } = d
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${esc(label)}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:10px">
        ${injs.map(inj => `
        <div style="display:flex;gap:12px;align-items:flex-start;padding:12px 14px;background:var(--bg3);border-radius:var(--r2);border-left:4px solid ${peptideColor(inj.peptideName)}">
          <div style="flex:1">
            <div class="row" style="margin-bottom:4px;flex-wrap:wrap;gap:8px">
              <span style="font-size:14px;font-weight:700;color:${peptideColor(inj.peptideName)}">${esc(inj.peptideName)}</span>
              ${inj.time ? `<span class="badge badge-gray">${fmt12(inj.time)}</span>` : ''}
              ${(() => { const u=(S.users||[]).find(x=>x.id===inj.userId); return u ? `<span class="badge" style="background:${u.color}22;color:${u.color}">${esc(u.name)}</span>` : '' })()}
            </div>
            <div style="display:flex;gap:16px;flex-wrap:wrap">
              ${inj.dosage ? `<div><div class="detail-label">Dosage</div><div style="font-size:13px;font-weight:600">${esc(inj.dosage)}</div></div>` : ''}
              ${inj.drawUnits ? `<div><div class="detail-label">Draw Units</div><div style="font-size:13px;font-weight:600">${esc(inj.drawUnits)}</div></div>` : ''}
              ${inj.notes ? `<div><div class="detail-label">Notes</div><div style="font-size:13px">${esc(inj.notes)}</div></div>` : ''}
            </div>
          </div>
          <button class="btn btn-danger btn-xs" onclick="deleteInjection('${inj.id}')">${ICONS.trash}</button>
        </div>`).join('')}
      </div>
      <div class="modal-ftr">
        <button class="btn btn-primary" onclick="closeModal()">Done</button>
      </div>
    </div>`
  }

  else if (S.modal === 'aiLabImport') {
    const hasKey = typeof hasAnthropicCredential === 'function' ? hasAnthropicCredential() : !!S.settings.anthropicKey
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>🤖 AI Lab Import</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:16px">
        ${!hasKey && isElectron ? `
        <div style="background:var(--yellowL);border:1px solid var(--border);border-radius:var(--r2);padding:14px 16px">
          <div style="font-size:13px;font-weight:600;color:var(--yellowT);margin-bottom:8px">API Key Required</div>
          <div style="font-size:13px;color:var(--text2);margin-bottom:10px">Enter your Anthropic API key. It is stored through Electron safeStorage, not normal settings.</div>
          <div class="row" style="gap:8px">
            <input class="form-input" id="ai-key-input" type="password" placeholder="sk-ant-..." style="flex:1;font-family:var(--mono);font-size:12px">
            <button class="btn btn-primary btn-sm" onclick="saveAnthropicKey()">Save Key</button>
          </div>
        </div>` : !hasKey ? `
        <div style="background:var(--yellowL);border:1px solid var(--border);border-radius:var(--r2);padding:14px 16px;font-size:13px;color:var(--yellowT)">
          Cloud AI is not verified. Configure the Worker <strong>ANTHROPIC_KEY</strong> secret, then use Settings → AI Integration → Refresh AI Status.
        </div>` : `
        <div style="background:var(--greenL);border-radius:var(--r2);padding:10px 14px;font-size:13px;color:var(--greenT)">
          ✓ API key configured
          ${isElectron ? `&nbsp;·&nbsp; preload v${window.api?.version?.() || '?'}
            ${(+(window.api?.version?.() || 0) < 2.6)
              ? `&nbsp;<span style="color:var(--red);font-weight:700">⚠ preload.js is out of date — copy all 3 src/ files and restart</span>`
              : `&nbsp;<span style="color:var(--green)">· IPC ready</span>`}` : ''}
        </div>`}

        <div style="font-size:13px;color:var(--text2)">
          Drop in your lab report and Claude will extract all markers automatically. Supports:
          <ul style="margin:8px 0 0 18px;line-height:1.8">
            <li><strong>PDF</strong> — scanned or digital lab reports (Ulta Labs, Quest, LabCorp, etc.)</li>
            <li><strong>Image</strong> — photo of your paper results</li>
            <li><strong>CSV / Text</strong> — exported data files</li>
          </ul>
        </div>

        <div id="ai-drop-zone"
          style="border:2px dashed var(--border2);border-radius:var(--r);padding:32px;text-align:center;cursor:pointer;transition:all .2s;background:var(--bg3)"
          onclick="document.getElementById('ai-file-input').click()"
          ondragover="event.preventDefault();this.style.borderColor='var(--blue)';this.style.background='var(--blueL)'"
          ondragleave="this.style.borderColor='var(--border2)';this.style.background='var(--bg3)'"
          ondrop="event.preventDefault();this.style.borderColor='var(--border2)';this.style.background='var(--bg3)';handleAILabDrop(event.dataTransfer.files[0])">
          <div style="font-size:32px;margin-bottom:8px">📄</div>
          <div style="font-size:15px;font-weight:600;color:var(--text2)">Drop file here or click to browse</div>
          <div style="font-size:12px;color:var(--text4);margin-top:4px">PDF, PNG, JPG, CSV, TXT</div>
          <input type="file" id="ai-file-input" accept=".pdf,.png,.jpg,.jpeg,.csv,.txt" style="display:none"
            onchange="handleAILabDrop(this.files[0])">
        </div>

        <div id="ai-lab-status" style="display:none;font-size:13px;color:var(--text2);text-align:center;padding:8px"></div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
      </div>
    </div>`
  }

  else if (S.modal === 'aiLabReview') {
    const { panelName, date, markers } = d
    const activeUsers = (S.users||[]).filter(u => u.active)
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>Review Extracted Results</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div style="background:var(--greenL);border-radius:var(--r2);padding:10px 14px;font-size:13px;color:var(--greenT)">
          ✓ Claude extracted ${markers.length} markers — review and edit below before saving
        </div>
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Panel Name *</label>
            <input class="form-input" id="f-panel-name" value="${esc(panelName||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Date *</label>
            <input class="form-input" type="date" id="f-panel-date" value="${date||localDateKey()}">
          </div>
        </div>
        ${activeUsers.length > 1 ? `
        <div class="form-group">
          <label class="form-label">User</label>
          <select class="form-input" id="f-panel-user">
            <option value="">— unassigned —</option>
            ${activeUsers.map(u => `<option value="${u.id}">${esc(u.name)}</option>`).join('')}
          </select>
        </div>` : ''}
        <div class="form-group">
          <label class="form-label">Markers</label>
          <div style="display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:4px;margin-bottom:4px;padding:0 2px">
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Marker Name</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Value</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Unit</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Ref Low</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Ref High</span>
            <span></span>
          </div>
          <div id="lab-marker-rows" style="display:flex;flex-direction:column;gap:4px">
            ${markers.map((m,i) => labMarkerRow(m, i)).join('')}
          </div>
          <button class="btn btn-secondary btn-sm" style="margin-top:8px" onclick="addLabMarkerRow()">${ICONS.plus} Add Marker</button>
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="openModal('aiLabImport')">← Back</button>
        <button class="btn btn-primary" onclick="saveAddLabPanel()">Save Panel</button>
      </div>
    </div>`
  }

  else if (S.modal === 'refillSupplements') {
    const supps = [...S.supplements].sort((a,b) => a.name.localeCompare(b.name))
    const today = localDateKey()
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>Refill Supplements</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Enter how many pills/capsules you reordered for each supplement. Amounts are <strong>added</strong> to what's on hand. Leave blank to skip. Each refill is logged with the date below.
        </div>
        <div class="form-group" style="max-width:220px">
          <label class="form-label">Refill Date</label>
          <input class="form-input" id="refill-date" type="date" value="${today}">
        </div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:2px">
          <button class="btn btn-ghost btn-xs" onclick="refillFilterSet('all')">Show All</button>
          <button class="btn btn-ghost btn-xs" onclick="refillFilterSet('low')">Only Low Stock</button>
          <span style="font-size:11px;color:var(--text4);align-self:center">Tip: type in only the ones you reordered</span>
        </div>
        <div style="max-height:48vh;overflow-y:auto;border:1px solid var(--border);border-radius:var(--r2)">
          <table class="tbl" style="margin:0">
            <thead><tr><th>Supplement</th><th style="text-align:right">On Hand</th><th style="text-align:right">Days Left</th><th style="width:120px">Add Qty</th></tr></thead>
            <tbody id="refill-rows">
              ${supps.map(s => {
                const days = suppDaysSupply(s)
                const isLow = days !== null && days <= +(s.lowStockDays||14)
                return `<tr data-refill-row data-low="${isLow?'1':'0'}">
                  <td style="font-size:13px">
                    <div style="font-weight:600">${esc(s.name)}</div>
                    <div style="font-size:11px;color:var(--text4)">${esc(s.strength||'')}${s.brand?` · ${esc(s.brand)}`:''} · ${SUPP_USER[s.takenBy]||s.takenBy}</div>
                  </td>
                  <td style="text-align:right;font-size:13px">${s.quantityOnHand||0}</td>
                  <td style="text-align:right;font-size:13px;color:${isLow?'var(--red)':'var(--text3)'}">${days!==null?days:'—'}</td>
                  <td><input class="form-input" type="number" min="0" placeholder="0" data-refill-id="${s.id}" style="width:100px;text-align:center" oninput="updateRefillCount()"></td>
                </tr>`
              }).join('')}
            </tbody>
          </table>
        </div>
        <div id="refill-summary" style="font-size:12px;color:var(--text3);padding:8px;background:var(--bg3);border-radius:var(--r2)">No refills entered yet</div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-secondary" onclick="openModal('refillHistory')">View History</button>
        <button class="btn btn-primary" onclick="applyRefills()">Apply Refills</button>
      </div>
    </div>`
  }

  else if (S.modal === 'refillHistory') {
    const log = [...(S.refillLog||[])].sort((a,b) => (b.date||'').localeCompare(a.date||'') || (b.at||'').localeCompare(a.at||''))
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>Refill History</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        ${log.length ? `
        <div style="max-height:55vh;overflow-y:auto;border:1px solid var(--border);border-radius:var(--r2)">
          <table class="tbl" style="margin:0">
            <thead><tr><th>Date</th><th>Supplement</th><th style="text-align:right">Added</th><th style="text-align:right">New Total</th></tr></thead>
            <tbody>
              ${log.map(r => `<tr>
                <td style="font-size:12px">${esc(r.date||'')}</td>
                <td style="font-size:13px;font-weight:600">${esc(r.name||'')}</td>
                <td style="text-align:right;font-size:13px;color:var(--green)">+${r.amount}</td>
                <td style="text-align:right;font-size:13px">${r.newTotal ?? '—'}</td>
              </tr>`).join('')}
            </tbody>
          </table>
        </div>
        <div style="font-size:11px;color:var(--text4)">${log.length} refill${log.length!==1?'s':''} logged</div>
        ` : `<div style="padding:32px;text-align:center;color:var(--text4);font-size:13px">No refills logged yet</div>`}
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="openModal('refillSupplements')">← Back to Refill</button>
        <button class="btn btn-secondary" onclick="closeModal()">Close</button>
      </div>
    </div>`
  }

  else if (S.modal === 'addSupplement' || S.modal === 'editSupplement') {
    const isEdit = S.modal === 'editSupplement'
    const s = isEdit ? S.supplements.find(x => x.id === d.suppId) : null
    const depletionAction = s?.depletionAction || (s?.replacedBy ? 'replace' : 'keep')
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${isEdit?'Edit':'Add'} Supplement</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Supplement Name *</label>
            <input class="form-input" id="f-supp-name" placeholder="e.g. Magnesium Glycinate" value="${esc(s?.name||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Strength / Dose</label>
            <input class="form-input" id="f-supp-strength" placeholder="e.g. 400mg, 1000 IU" value="${esc(s?.strength||'')}">
          </div>
        </div>
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Form</label>
            <select class="form-input form-select" id="f-supp-form">
              <option value="">— Select —</option>
              ${SUPP_FORMS.map(f=>`<option ${s?.form===f?'selected':''}>${f}</option>`).join('')}
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Brand</label>
            <input class="form-input" id="f-supp-brand" placeholder="e.g. Thorne, NOW Foods" value="${esc(s?.brand||'')}">
          </div>
        </div>
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Category</label>
            <select class="form-input form-select" id="f-supp-cat" onchange="const ci=document.getElementById('f-supp-cat-custom');if(this.value==='__custom__'){this.style.display='none';ci.style.display='block';ci.focus()}">
              <option value="">— Select —</option>
              ${suppCategories().map(c => `<option value="${esc(c)}" ${s?.category===c?'selected':''}>${esc(c)}</option>`).join('')}
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Subcategory</label>
            <select class="form-input form-select" id="f-supp-subcat" onchange="const si=document.getElementById('f-supp-subcat-custom');if(this.value==='__custom__'){this.style.display='none';si.style.display='block';si.focus()}">
              <option value="">— Select —</option>
              ${[...new Set((S.supplements||[]).map(s=>s.subcategory).filter(Boolean))].sort().map(c => `<option value="${esc(c)}" ${s?.subcategory===c?'selected':''}>${esc(c)}</option>`).join('')}
            </select>
          </div>
        </div>

        <div style="background:var(--blueL);border-radius:var(--r2);padding:12px 14px">
          <div style="font-size:11px;font-weight:700;color:var(--blue2);text-transform:uppercase;letter-spacing:.4px;margin-bottom:10px">Inventory & Dosing</div>
          <div class="form-row form-row-3">
            <div class="form-group" style="margin:0">
              <label class="form-label">Qty On Hand <span style="font-weight:400;color:var(--text4)">(pills, capsules, etc.)</span></label>
              <input class="form-input" id="f-supp-qty" type="number" min="0" step="1" placeholder="0" value="${esc(s?.quantityOnHand??'')}" oninput="updateSuppCalc()">
            </div>
            <div class="form-group" style="margin:0">
              <label class="form-label">Status</label>
              <select class="form-input form-select" id="f-supp-status" onchange="toggleSuppProtocolLinks()">
                <option value="active" ${(s?.status||'active')==='active'?'selected':''}>Active</option>
                <option value="phase_out" ${s?.status==='phase_out'?'selected':''}>Phase Out</option>
                <option value="pending" ${s?.status==='pending'?'selected':''}>Pending</option>
                <option value="protocol" ${s?.status==='protocol'?'selected':''}>Protocol</option>
                <option value="inactive" ${s?.status==='inactive'?'selected':''}>Inactive</option>
              </select>
            </div>
            <div class="form-group" style="margin:0">
              <label class="form-label">Time of Day</label>
              <select class="form-input form-select" id="f-supp-time" onchange="updateSuppCalc();toggleSuppProtocolLinks()">
                <option value="am"       ${(s?.timeOfDay||'am')==='am'      ?'selected':''}>AM (Morning)</option>
                <option value="noon"     ${s?.timeOfDay==='noon'    ?'selected':''}>Noon (Lunch)</option>
                <option value="pm"       ${s?.timeOfDay==='pm'      ?'selected':''}>PM (Evening)</option>
                <option value="both"     ${s?.timeOfDay==='both'    ?'selected':''}>AM + PM (Twice Daily)</option>
                <option value="protocol" ${s?.timeOfDay==='protocol'?'selected':''}>Protocol</option>
              </select>
            </div>
          </div>
          <div class="form-group" id="f-supp-protocol-links-wrap" style="display:${s?.status==='protocol'||s?.timeOfDay==='protocol'?'block':'none'};margin-top:10px">
            <label class="form-label">Activation Schedule</label>
            <select class="form-input form-select" id="f-supp-protocol-links" multiple size="6">
              ${[...(S.protocols||[])].filter(protocol => !protocol.archived && !protocol.supersededByImport).sort((a,b) => String(a.sourceColumnName||a.peptideName||a.name||'').localeCompare(String(b.sourceColumnName||b.peptideName||b.name||''))).map(protocol => {
                const label = protocol.sourceColumnName || protocol.peptideName || protocol.name || 'Unnamed protocol'
                const dates = [protocol.startDate, protocol.endDate].filter(Boolean).join(' – ')
                const selectedByName = (s?.linkedProtocolNames||[]).some(name => String(name).trim().toLowerCase() === String(label).trim().toLowerCase())
                return `<option value="${esc(protocol.id)}" data-schedule-name="${esc(label)}" ${(s?.linkedProtocolIds||[]).includes(protocol.id)||selectedByName?'selected':''}>${esc(label)}${dates?' · '+esc(dates):''}</option>`
              }).join('')}
            </select>
            <div style="font-size:11px;color:var(--text4);margin-top:5px">Choose one or more imported schedules. Use the shared <strong>Supplements</strong> schedule for its linked pills. A supplement whose name exactly matches a master-protocol column, such as SLU-PP-332, links automatically.</div>
          </div>
          <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">When Stock Reaches Zero</label>
            <select class="form-input form-select" id="f-supp-depletion-action" onchange="const w=document.getElementById('f-supp-replacement-wrap');if(w)w.style.display=this.value==='replace'?'block':'none'">
              <option value="keep" ${depletionAction==='keep'?'selected':''}>Keep active for restock</option>
              <option value="replace" ${depletionAction==='replace'?'selected':''}>Replace with another supplement</option>
              <option value="discontinue" ${depletionAction==='discontinue'?'selected':''}>Discontinue / phase out</option>
            </select>
          </div>
          <div class="form-group" id="f-supp-replacement-wrap" style="display:${depletionAction==='replace'?'block':'none'}">
            <label class="form-label">Replacement Supplement</label>
            <select class="form-input form-select" id="f-supp-replacedby">
              <option value="">— None —</option>
              ${[...S.supplements].filter(x => x.id !== (s?.id||'')).sort((a,b) => a.name.localeCompare(b.name)).map(x =>
                `<option value="${x.id}" ${s?.replacedBy===x.id?'selected':''}>${esc(x.name)}${x.strength?' ('+esc(x.strength)+')':''}${(x.status||'active')==='inactive'?' [Inactive]':''}</option>`
              ).join('')}
            </select>
          </div>
          </div>
          <!-- Serving size — single or split AM/PM -->
          <div id="f-supp-serving-single" style="display:${(s?.timeOfDay||'am')==='both'?'none':'block'}">
            <div class="form-group" style="margin:0">
              <label class="form-label">Serving Size <span style="font-weight:400;color:var(--text4)">(pills per dose)</span></label>
              <input class="form-input" id="f-supp-daily" type="number" min="1" step="1" placeholder="1" value="${esc(s?.dailyServing??1)}" oninput="updateSuppCalc()">
            </div>
          </div>
          <div id="f-supp-serving-split" style="display:${s?.timeOfDay==='both'?'block':'none'}">
            <div class="form-row form-row-2" style="margin:0">
              <div class="form-group" style="margin:0">
                <label class="form-label">☀️ AM Serving <span style="font-weight:400;color:var(--text4)">(pills)</span></label>
                <input class="form-input" id="f-supp-serving-am" type="number" min="1" step="1" placeholder="1" value="${esc(s?.servingAM??s?.dailyServing??1)}" oninput="updateSuppCalc()">
              </div>
              <div class="form-group" style="margin:0">
                <label class="form-label">🌙 PM Serving <span style="font-weight:400;color:var(--text4)">(pills)</span></label>
                <input class="form-input" id="f-supp-serving-pm" type="number" min="1" step="1" placeholder="1" value="${esc(s?.servingPM??s?.dailyServing??1)}" oninput="updateSuppCalc()">
              </div>
            </div>
          </div>
          <div class="form-group" style="margin-top:8px">
            <label class="form-label">Taken By</label>
            <select class="form-input form-select" id="f-supp-by" onchange="updateSuppCalc();toggleSuppDosageOverride()">
              <option value="todd"   ${(s?.takenBy||'todd')==='todd'  ?'selected':''}>Todd</option>
              <option value="meagan" ${s?.takenBy==='meagan'?'selected':''}>Meagan</option>
              <option value="both"   ${s?.takenBy==='both'  ?'selected':''}>Both (Todd &amp; Meagan)</option>
            </select>
          </div>

          <!-- Multi-user dosage override -->
          <div id="f-supp-dosage-override-wrap" style="display:${(s?.takenBy||'todd')==='both'?'block':'none'};margin-top:8px">
            <label style="display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer">
              <input type="checkbox" id="f-supp-dosages-different" ${s?.dosagesDifferent?'checked':''} onchange="toggleSuppDosageOverride()">
              Dosages Different <span style="font-weight:400;color:var(--text4)">(Todd and Meagan take different amounts)</span>
            </label>
            <div id="f-supp-dosage-detail" style="display:${s?.dosagesDifferent?'grid':'none'};grid-template-columns:1fr 1fr;gap:10px;margin-top:8px;background:var(--purpleL);border-radius:var(--r2);padding:10px 12px">
              <div>
                <div style="font-size:11px;font-weight:700;color:var(--blue2);margin-bottom:6px">Todd</div>
                <div class="row" style="gap:6px">
                  <input class="form-input" id="f-supp-dose-todd-am" type="number" min="0" step="1" placeholder="AM" value="${esc(s?.userDosages?.todd?.am ?? '')}" style="text-align:center">
                  <input class="form-input" id="f-supp-dose-todd-noon" type="number" min="0" step="1" placeholder="Noon" value="${esc(s?.userDosages?.todd?.noon ?? '')}" style="text-align:center">
                  <input class="form-input" id="f-supp-dose-todd-pm" type="number" min="0" step="1" placeholder="PM" value="${esc(s?.userDosages?.todd?.pm ?? '')}" style="text-align:center">
                </div>
              </div>
              <div>
                <div style="font-size:11px;font-weight:700;color:var(--purpleT);margin-bottom:6px">Meagan</div>
                <div class="row" style="gap:6px">
                  <input class="form-input" id="f-supp-dose-meagan-am" type="number" min="0" step="1" placeholder="AM" value="${esc(s?.userDosages?.meagan?.am ?? '')}" style="text-align:center">
                  <input class="form-input" id="f-supp-dose-meagan-noon" type="number" min="0" step="1" placeholder="Noon" value="${esc(s?.userDosages?.meagan?.noon ?? '')}" style="text-align:center">
                  <input class="form-input" id="f-supp-dose-meagan-pm" type="number" min="0" step="1" placeholder="PM" value="${esc(s?.userDosages?.meagan?.pm ?? '')}" style="text-align:center">
                </div>
              </div>
            </div>
          </div>

          <!-- Live calculation -->
          <div id="supp-calc-result" style="margin-top:10px;background:white;border-radius:var(--r2);padding:10px 12px;font-size:13px"></div>
        </div>

        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Low Stock Alert <span style="font-weight:400;color:var(--text4)">(days remaining)</span></label>
            <input class="form-input" id="f-supp-lowstock" type="number" min="0" placeholder="14" value="${esc(s?.lowStockDays??14)}">
          </div>
          <div class="form-group">
            <label class="form-label">Expiry Date</label>
            <input class="form-input" type="date" id="f-supp-expiry" value="${esc(s?.expiryDate||'')}">
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Reorder URL</label>
          <input class="form-input" id="f-supp-url" placeholder="https://amazon.com/..." value="${esc(s?.reorderUrl||'')}">
        </div>
        <div class="form-row">
          <div class="form-group" style="flex:1">
            <label class="form-label">Notes</label>
            <textarea class="form-input" id="f-supp-notes" rows="2" placeholder="Any additional notes…">${esc(s?.notes||'')}</textarea>
          </div>
          <div class="form-group" style="flex:1">
            <label class="form-label">NIIMBOT Label</label>
            <input class="form-input mono" id="f-supp-niimlabel" placeholder="⊙abc123⊙" value="${esc(s?.niimLabel||'')}">
          </div>
          <div class="form-group" style="flex:1">
            <label class="form-label">NIIMBOT QR</label>
            <input class="form-input mono" id="f-supp-niimqr" placeholder="⊙def456⊙" value="${esc(s?.niimQR||'')}">
          </div>
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit?`saveEditSupplement('${d.suppId}')`:'saveAddSupplement()'}">${isEdit?'Save':'Add Supplement'}</button>
      </div>
    </div>`
    // Trigger calc after render
    setTimeout(updateSuppCalc, 50)
  }

  else if (S.modal === 'addUser' || S.modal === 'editUser') {
    const isEdit = S.modal === 'editUser'
    const u = isEdit ? S.users.find(x => x.id === d.userId) : null
    const colors = ['#0072B2','#CC79A7','#009E73','#E69F00','#D55E00','#56B4E9','#F0E442','#000000']
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>${isEdit?'Edit':'Add'} User</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div class="form-group">
          <label class="form-label">Name *</label>
          <input class="form-input" id="f-user-name" placeholder="e.g. Todd" value="${esc(u?.name||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Initials</label>
          <input class="form-input" id="f-user-initials" maxlength="3" placeholder="e.g. TO" value="${esc(u?.initials||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Color</label>
          <div class="row" style="gap:6px;flex-wrap:wrap">
            ${colors.map(c => `<button type="button" onclick="document.getElementById('f-user-color').value='${c}';document.querySelectorAll('.color-swatch').forEach(el=>el.style.outline='none');this.style.outline='2px solid var(--text)'" class="color-swatch" style="width:28px;height:28px;border-radius:50%;background:${c};border:none;cursor:pointer;${u?.color===c?'outline:2px solid var(--text)':''}"></button>`).join('')}
          </div>
          <input type="hidden" id="f-user-color" value="${esc(u?.color||colors[0])}">
        </div>
        <div class="form-group">
          <label class="form-label">Age <span style="font-weight:400;color:var(--text4)">(optional)</span></label>
          <input class="form-input" id="f-user-age" type="number" min="0" value="${esc(u?.age||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Notes</label>
          <textarea class="form-input" id="f-user-notes" rows="2">${esc(u?.notes||'')}</textarea>
        </div>
        <label style="display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer">
          <input type="checkbox" id="f-user-active" ${(u?.active!==false)?'checked':''}> Active
        </label>
      </div>
      <div class="modal-ftr">
        ${isEdit ? `<button class="btn btn-danger" onclick="deleteUser('${d.userId}')">Delete</button>` : ''}
        <div class="spacer"></div>
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit?`saveEditUser('${d.userId}')`:'saveAddUser()'}">${isEdit?'Save':'Add User'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'categoryAssign') {
    const label = S._assignCategory || ''
    const peps = (S.peptides||[]).filter(p => !p.archived).sort((a,b) => a.name.localeCompare(b.name))
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>Manage Peptides — ${esc(label)}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:10px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Check the peptides that belong to <strong>${esc(label)}</strong>. Changes save when you click Done.
        </div>
        <div style="max-height:50vh;overflow-y:auto;border:1px solid var(--border);border-radius:var(--r2)">
          ${peps.length ? peps.map(p => {
            const checked = (p.categories||[]).includes(label) ? 'checked' : ''
            return `<label style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-bottom:1px solid var(--border2);cursor:pointer;font-size:13px">
              <input type="checkbox" data-assign-pep="${p.id}" ${checked}>
              <span style="flex:1"><strong>${esc(p.name)}</strong>${p.customVialName?`<span style="color:var(--text3)"> — ${esc(p.customVialName)}</span>`:''}</span>
              ${(p.categories||[]).length ? `<span style="font-size:10px;color:var(--text4)">${esc((p.categories||[]).join(', '))}</span>` : ''}
            </label>`
          }).join('') : '<div style="padding:20px;text-align:center;color:var(--text4);font-size:13px">No peptides in inventory yet. Add some first.</div>'}
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="saveCategoryAssign()">Done</button>
      </div>
    </div>`
  }

  else if (S.modal === 'editCategory') {
    const cat = (S.customCategories||[]).find(c => c.label === S._editCategory)
    content = cat ? `
    <div class="modal">
      <div class="modal-hdr">
        <h3>Edit Category</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div class="form-group">
          <label class="form-label">Category Name</label>
          <input class="form-input" id="f-editcat-name" value="${esc(cat.label)}" onkeydown="if(event.key==='Enter'){event.preventDefault();saveCategoryEdit()}">
        </div>
        <div class="form-group">
          <label class="form-label">Description <span style="font-weight:400;color:var(--text4)">(optional)</span></label>
          <input class="form-input" id="f-editcat-desc" value="${esc(cat.desc||'')}">
        </div>
        <div style="font-size:11px;color:var(--text4)">Renaming updates this category on all peptides currently assigned to it.</div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="saveCategoryEdit()">Save</button>
      </div>
    </div>` : '<div class="modal"><div class="modal-body">Category not found</div></div>'
  }

  else if (S.modal === 'addCategory') {
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>New Category</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Create a category to group your peptides. Once created, it appears as a card here and in the category dropdown when editing library entries.
        </div>
        <div class="form-group">
          <label class="form-label">Category Name</label>
          <input class="form-input" id="f-newcat-name" placeholder="e.g. Cognitive / Nootropic" autofocus onkeydown="if(event.key==='Enter'){event.preventDefault();saveNewCategory()}">
          <div style="font-size:11px;color:var(--text4);margin-top:4px">Tip: use a "Group / Subgroup" format (like "GH Axis / Recovery") to nest related categories under the same card.</div>
        </div>
        <div class="form-group">
          <label class="form-label">Description <span style="font-weight:400;color:var(--text4)">(optional)</span></label>
          <input class="form-input" id="f-newcat-desc" placeholder="What this category is for">
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="saveNewCategory()">Create Category</button>
      </div>
    </div>`
  }

  else if (S.modal === 'addLibraryEntry' || S.modal === 'editLibraryEntry') {
    const isEdit = S.modal === 'editLibraryEntry'
    const e = isEdit ? S.peptideLibrary.find(x => x.id === d.libId) : null
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>${isEdit?'Edit':'Add'} Library Entry</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div class="form-group">
          <label class="form-label">Scientific Name *</label>
          <input class="form-input" id="f-lib-sci" placeholder="e.g. MOTS-C" value="${esc(e?.scientificName||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Custom Vial / Display Name</label>
          <input class="form-input" id="f-lib-vial" placeholder="e.g. Mitochondrial Activation Complex" value="${esc(e?.customVialName||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Aliases <span style="font-weight:400;color:var(--text4)">(comma separated)</span></label>
          <input class="form-input" id="f-lib-aliases" placeholder="e.g. Elamipretide, SS31" value="${esc((e?.aliases||[]).join(', '))}">
        </div>
        <div class="form-group">
          <label class="form-label">Categories</label>
          <select class="form-input form-select" id="f-lib-cats" multiple style="height:140px">
            ${getAllCategories().map(c => `<option value="${esc(c.label)}" ${(e?.categories||[]).includes(c.label)?'selected':''}>${esc(c.label)}</option>`).join('')}
          </select>
          <div style="font-size:11px;color:var(--text4);margin-top:4px">Cmd/Ctrl+click to select multiple</div>
          <div class="row" style="gap:6px;margin-top:8px">
            <input class="form-input" id="f-lib-newcat" placeholder="+ Create a new category…" style="flex:1" onkeydown="if(event.key==='Enter'){event.preventDefault();createCategoryFromModal()}">
            <button type="button" class="btn btn-secondary btn-sm" onclick="createCategoryFromModal()">Add</button>
          </div>
        </div>
        <label style="display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer">
          <input type="checkbox" id="f-lib-blend" ${e?.isBlend?'checked':''}> Is Blend
        </label>
        <label style="display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer">
          <input type="checkbox" id="f-lib-active" ${(e?.active!==false)?'checked':''}> Active
        </label>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit?`saveEditLibraryEntry('${d.libId}')`:'saveAddLibraryEntry()'}">${isEdit?'Save':'Add'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'addLabPanel' || S.modal === 'editLabPanel') {
    const isEdit = S.modal === 'editLabPanel'
    const panel = isEdit ? S.labResults.find(p => p.id === d.panelId) : null
    const markers = panel?.markers || d._markers || [{ id:uid(), name:'', value:'', unit:'', refLow:'', refHigh:'' }]
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${isEdit?'Edit':'Add'} Lab Panel</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Panel Name *</label>
            <input class="form-input" id="f-panel-name" placeholder="e.g. Q1 2026 Ulta Labs" value="${esc(panel?.panelName||'')}">
          </div>
          <div class="form-group">
            <label class="form-label">Date *</label>
            <input class="form-input" type="date" id="f-panel-date" value="${panel?.date||localDateKey()}">
          </div>
        </div>
        ${(S.users||[]).filter(u=>u.active).length > 1 ? `
        <div class="form-group">
          <label class="form-label">User</label>
          <select class="form-input" id="f-panel-user">
            <option value="">— unassigned —</option>
            ${(S.users||[]).filter(u=>u.active).map(u => `<option value="${u.id}" ${panel?.userId===u.id?'selected':''}>${esc(u.name)}</option>`).join('')}
          </select>
        </div>` : ''}
        <div class="form-group">
          <label class="form-label">Markers</label>
          <div style="display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:4px;margin-bottom:4px;padding:0 2px">
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Marker Name</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Value</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Unit</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Ref Low</span>
            <span style="font-size:10px;font-weight:700;color:var(--text4)">Ref High</span>
            <span></span>
          </div>
          <div id="lab-marker-rows" style="display:flex;flex-direction:column;gap:4px">
            ${markers.map((m,i) => labMarkerRow(m, i)).join('')}
          </div>
          <button class="btn btn-secondary btn-sm" style="margin-top:8px" onclick="addLabMarkerRow()">${ICONS.plus} Add Marker</button>
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit?`saveEditLabPanel('${d.panelId}')`:'saveAddLabPanel()'}">${isEdit?'Save':'Add Panel'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'icsRange') {
    const n = countInjectionsInRange(S.icsRangeStart, S.icsRangeEnd, S.icsUserFilter)
    const tooMany = n > 1000
    const activeUsers = (S.users||[]).filter(u=>u.active)
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>Export Calendar (ICS)</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Choose whose injections and which date range to export. Google Calendar can reject very large files, so exporting in windows (a few months at a time) imports most reliably.
        </div>
        ${activeUsers.length ? `
        <div class="form-group">
          <label class="form-label">Whose calendar</label>
          <select class="form-input form-select" id="ics-user-filter" onchange="updateICSRangeCount()">
            <option value="all" ${(S.icsUserFilter||'all')==='all'?'selected':''}>Everyone</option>
            ${activeUsers.map(u => `<option value="${u.id}" ${S.icsUserFilter===u.id?'selected':''}>${esc(u.name)}</option>`).join('')}
          </select>
        </div>` : ''}
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">From</label>
            <input class="form-input" id="ics-range-start" type="date" value="${esc(S.icsRangeStart||'')}" oninput="updateICSRangeCount()">
          </div>
          <div class="form-group">
            <label class="form-label">To</label>
            <input class="form-input" id="ics-range-end" type="date" value="${esc(S.icsRangeEnd||'')}" oninput="updateICSRangeCount()">
          </div>
        </div>
        <div style="display:flex;gap:6px;flex-wrap:wrap">
          <button class="btn btn-ghost btn-xs" onclick="setICSPreset(30)">Next 30 days</button>
          <button class="btn btn-ghost btn-xs" onclick="setICSPreset(90)">Next 90 days</button>
          <button class="btn btn-ghost btn-xs" onclick="setICSPreset(180)">Next 6 months</button>
          <button class="btn btn-ghost btn-xs" onclick="setICSPreset(365)">Next 12 months</button>
        </div>
        <div id="ics-range-count" style="font-size:13px;padding:10px;background:var(--bg3);border-radius:var(--r2)">
          <strong style="color:${tooMany?'var(--red)':'inherit'}">${n}</strong> event${n!==1?'s':''} in range${tooMany?' <span style="color:var(--red)">— Google may reject more than ~1,000. Narrow the range.</span>':''}
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="confirmICSExport()">Export ICS</button>
      </div>
    </div>`
  }

  else if (S.modal === 'addNote' || S.modal === 'editNote') {
    const isEdit = S.modal === 'editNote'
    const note = isEdit ? S.notes.find(n => n.id === d.noteId) : null
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>${isEdit ? 'Edit Note' : 'Add Note'}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        <div class="form-row form-row-2">
          <div class="form-group">
            <label class="form-label">Date *</label>
            <input class="form-input" id="f-note-date" type="date" value="${note?.date || localDateKey()}">
          </div>
          <div class="form-group">
            <label class="form-label">Link to Peptide</label>
            <select class="form-input form-select" id="f-note-pep">
              <option value="">— None —</option>
              ${S.peptides.map(p=>`<option value="${p.id}" ${note?.peptideId===p.id?'selected':''}>${esc(p.name)}</option>`).join('')}
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Title *</label>
          <input class="form-input" id="f-note-title" placeholder="e.g. Week 3 observations" value="${esc(note?.title||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Notes</label>
          <textarea class="form-input" id="f-note-body" rows="6" placeholder="Observations, side effects, protocol changes…">${esc(note?.body||'')}</textarea>
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit?`saveEditNote('${d.noteId}')`:'saveAddNote()'}">${isEdit?'Save':'Add Note'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'syncHealth') {
    const { rows, total } = storageSizeBreakdown()
    const importTx = countImportTransactions().importTx
    const healthCount = (S.healthData||[]).length
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>Sync Data Breakdown</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Total data: <strong>${(total/1024).toFixed(0)} KB</strong> across ${rows.length} types. Sync now sends each type as its own request, so large items no longer block syncing.
        </div>
        <div style="border:1px solid var(--border);border-radius:var(--r2);overflow:hidden">
          <table class="tbl" style="margin:0">
            <thead><tr><th>Data</th><th>Items</th><th style="text-align:right">Size</th></tr></thead>
            <tbody>
              ${rows.map(r => `<tr>
                <td style="font-size:13px">${esc(r.key)}</td>
                <td style="font-size:13px;color:var(--text3)">${r.count}</td>
                <td style="font-size:13px;text-align:right;font-weight:600">${(r.bytes/1024).toFixed(1)} KB</td>
              </tr>`).join('')}
            </tbody>
          </table>
        </div>
        ${importTx ? `
        <div style="display:flex;flex-direction:column;gap:8px">
          <div style="font-size:13px;font-weight:600">Cleanup</div>
          <button class="btn btn-secondary btn-sm" onclick="openImportCleanup()">Remove ${importTx} import transactions</button>
          <div style="font-size:11px;color:var(--text4);line-height:1.4">Removes the "Imported into…" transactions (and their offsets) created by storage imports. Your peptides, SKUs, and history are otherwise untouched.</div>
        </div>` : ''}
        ${(() => {
          const hdDups = countDuplicates(S.healthData || [])
          const injDups = countDuplicates(S.injections || [])
          if (!hdDups && !injDups) return ''
          return `<div style="display:flex;flex-direction:column;gap:8px">
            <div style="font-size:13px;font-weight:600">Duplicate Cleanup</div>
            <div style="font-size:12px;color:var(--text3);line-height:1.5">Sync issues may have created duplicate records. Dedup keeps one copy of each unique record by ID.</div>
            ${hdDups ? `<button class="btn btn-secondary btn-sm" onclick="dedupArray('healthData');openModal('syncHealth')">Remove ${hdDups} duplicate health records</button>` : ''}
            ${injDups ? `<button class="btn btn-secondary btn-sm" onclick="dedupArray('injections');openModal('syncHealth')">Remove ${injDups} duplicate injections</button>` : ''}
          </div>`
        })()}
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Close</button>
        ${S.settings.cloudToken ? `<button class="btn btn-primary" onclick="closeModal();syncToCloud()">↑ Push to Cloud Now</button>` : ''}
      </div>
    </div>`
  }

  else if (S.modal === 'importCleanup') {
    const { importTx, vials } = countImportTransactions()
    const payloadKB = Math.round(JSON.stringify({peptides:S.peptides}).length / 1024)
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>Clean Up Import Transactions</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Earlier storage imports left behind <strong>"Imported into …"</strong> stock transactions that inflated SKU totals and bloated your sync data. This removes only those transactions — your real scan-in/scan-out history and your per-location placements are untouched.
        </div>
        <div style="background:var(--bg3);border-radius:var(--r2);padding:12px;font-size:13px">
          <div style="display:flex;justify-content:space-between;margin-bottom:4px"><span style="color:var(--text3)">Import transactions to remove</span><strong>${importTx}</strong></div>
          <div style="display:flex;justify-content:space-between"><span style="color:var(--text3)">Vials they accounted for</span><strong>${vials}</strong></div>
        </div>
        <div style="font-size:12px;color:var(--text4)">After cleanup, SKU stock totals reflect only your genuine scan/manual transactions. Smaller data also makes cloud sync more reliable.</div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-danger" onclick="runImportCleanup()">Remove ${importTx} Transaction${importTx!==1?'s':''}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'clearInventory') {
    let locAssignments = 0, totalVials = 0
    for (const p of (S.peptides||[])) for (const s of (p.skus||[])) for (const l of (s.locations||[])) {
      if ((l.qty||0) > 0) { locAssignments++; totalVials += (l.qty||0) }
    }
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>Clear Location Inventory</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Empties what's stored in each location. Your <strong>storage locations stay</strong> (Fridge, Freezer, etc.), and your <strong>peptides and SKUs are not deleted</strong> — only the per-location placements and quantities are cleared. Good for re-importing a fresh inventory into the same locations.
        </div>
        <div style="background:var(--bg3);border-radius:var(--r2);padding:12px;font-size:13px">
          <div style="display:flex;justify-content:space-between;margin-bottom:4px"><span style="color:var(--text3)">Location assignments to clear</span><strong>${locAssignments}</strong></div>
          <div style="display:flex;justify-content:space-between"><span style="color:var(--text3)">Vials placed in locations</span><strong>${totalVials}</strong></div>
        </div>
        <div style="font-size:11px;color:var(--text4)">SKU stock totals come from in/out transactions and won't change — this only resets where things are placed.</div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-danger" onclick="clearLocationInventory()">Clear Inventory</button>
      </div>
    </div>`
  }

  else if (S.modal === 'deleteLocations') {
    content = `
    <div class="modal">
      <div class="modal-hdr">
        <h3>Delete Locations</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:14px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          Deletes all <strong>${S.storageLocations.length} storage location${S.storageLocations.length!==1?'s':''}</strong> (Fridge, Freezer, etc.). Any inventory placed in them is cleared too, since the locations no longer exist. Your <strong>peptides and SKUs are not deleted</strong> — only the locations and their placements.
        </div>
        <div style="font-size:11px;color:var(--text4)">Use "Clear Location Inventory" instead if you want to keep the locations and just empty them.</div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-danger" onclick="deleteAllLocations()">Delete All Locations</button>
      </div>
    </div>`
  }

  else if (S.modal === 'storageImportSkips') {
    const rows = S._lastStorageSkips || []
    content = `
    <div class="modal modal-lg">
      <div class="modal-hdr">
        <h3>Some Rows Didn't Import</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          ${rows.length} row${rows.length!==1?'s':''} couldn't be matched to an existing supply and ${rows.length!==1?'were':'was'} skipped. Download them, fix the names (or add the supplies first), then re-import.
        </div>
        <div style="max-height:40vh;overflow-y:auto;border:1px solid var(--border);border-radius:var(--r2)">
          <table class="tbl" style="margin:0">
            <thead><tr><th>Location</th><th>Supply</th><th>SKU</th><th>Qty</th><th>Reason</th></tr></thead>
            <tbody>
              ${rows.slice(0,50).map(r => `<tr>
                <td style="font-size:12px">${esc(r.loc)}</td>
                <td style="font-size:12px;font-weight:600">${esc(r.pep)}</td>
                <td style="font-size:12px;color:var(--text3)">${esc(r.sku)}</td>
                <td style="font-size:12px">${esc(r.qty)}</td>
                <td style="font-size:11px;color:var(--red)">${esc(r.reason)}</td>
              </tr>`).join('')}
            </tbody>
          </table>
          ${rows.length > 50 ? `<div style="padding:8px 12px;font-size:11px;color:var(--text4)">+${rows.length-50} more in the download</div>` : ''}
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Close</button>
        <button class="btn btn-primary" onclick="downloadStorageSkips()">${ICONS.export} Download Unmatched CSV</button>
      </div>
    </div>`
  }

  else if (S.modal === 'pullLocation') {
    const ctx = S._txPull || {}
    const s = getSku(ctx.pid, ctx.sid)
    const p = getPeptide(ctx.pid)
    const assignmentIds = new Set(ctx.assignmentIds || [])
    const stocked = (S.vaultAssignments || []).filter(a => assignmentIds.has(a.id) && +(a.qty || 0) > 0).map(a => ({
      assignment:a,
      position:(S.vaultPositions || []).find(pos => pos.id === a.positionId)
    })).sort((a,b) => (+a.position?.number || 0) - (+b.position?.number || 0))
    const unlocated = Math.max(0, ctx.unlocated || 0)
    content = `
    <div class="modal" style="width:min(440px,calc(100vw - 32px))">
      <div class="modal-hdr">
        <h3>Where are you pulling from?</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body" style="gap:12px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">
          ${ctx.inventoryAlreadyRemoved ? 'Inventory was already reduced. Update the physical map by choosing' : 'Removing'} <strong>${ctx.qty} vial${ctx.qty!==1?'s':''}</strong> of <strong>${esc(p?.name||'')}</strong>${s?.barcode?` <span style="color:var(--text4)">(${esc(s.barcode)})</span>`:''}${ctx.inventoryAlreadyRemoved ? '.' : `. Enter how many to pull from each source. The amounts must total ${ctx.qty}.`}
        </div>
        <div style="display:flex;flex-direction:column;gap:8px">
          ${unlocated > 0 ? `<div class="row" style="gap:10px;align-items:center">
              <div style="flex:1">
                <div style="font-size:13px;font-weight:600">📦 Not in Storage</div>
                <div style="font-size:11px;color:var(--text4)">${unlocated} unassigned</div>
              </div>
              <input class="form-input" id="pull-__unlocated__" type="number" min="0" max="${unlocated}" placeholder="0" style="width:90px;text-align:center" oninput="updatePullTotal(${ctx.qty})">
            </div>` : ''}
          ${stocked.map(row => {
            const assignment = row.assignment
            const locationName = row.position?.code || assignment.positionId || 'Unknown holder'
            return `<div class="row" style="gap:10px;align-items:center">
              <div style="flex:1">
                <div style="font-size:13px;font-weight:600">📍 ${esc(locationName)}</div>
                <div style="font-size:11px;color:var(--text4)">${assignment.qty} vial${+assignment.qty!==1?'s':''} in this ${esc(row.position?.holderType || 'holder')}</div>
              </div>
              <input class="form-input" id="pull-vault-${assignment.id}" type="number" min="0" max="${assignment.qty}" placeholder="0" style="width:90px;text-align:center" oninput="updatePullTotal(${ctx.qty})">
            </div>`
          }).join('')}
        </div>
        <div id="pull-total-hint" style="font-size:12px;color:var(--text3);padding:8px;background:var(--bg3);border-radius:var(--r2)">Enter amounts totaling ${ctx.qty}</div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="confirmPullLocation()">${ctx.inventoryAlreadyRemoved?'Update Map':'Remove '+ctx.qty+' vial'+(ctx.qty!==1?'s':'')}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'pullInjSupplyLocation') {
    const ctx = S._injSupplyPull || {}
    const supply = getInjSupply(ctx.supplyId)
    const sku = getInjSku(ctx.supplyId, ctx.skuId)
    const stocked = (sku?.locations || []).filter(l => +l.qty > 0)
    const unlocated = Math.max(0, +ctx.unlocated || 0)
    content = `<div class="modal" style="width:min(460px,calc(100vw - 32px))">
      <div class="modal-hdr"><h3>Remove supply inventory</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body" style="gap:12px">
        <div style="font-size:13px;color:var(--text3);line-height:1.5">Removing <strong>${ctx.qty} EA</strong> of <strong>${esc(supply?.name || 'Supply')}</strong>. Choose exactly where each item is being removed from.</div>
        <div style="display:flex;flex-direction:column;gap:8px">
          ${unlocated > 0 ? `<div class="row" style="gap:10px;align-items:center"><div style="flex:1"><div style="font-size:13px;font-weight:600">📦 Not assigned to storage</div><div style="font-size:11px;color:var(--text4)">${unlocated} available</div></div><input class="form-input" id="is-pull-__unlocated__" type="number" min="0" max="${unlocated}" placeholder="0" style="width:90px;text-align:center" oninput="updateInjSupplyPullTotal(${ctx.qty})"></div>` : ''}
          ${stocked.map(l => { const name=(S.storageLocations||[]).find(x=>x.id===l.locationId)?.name||'Unknown location'; return `<div class="row" style="gap:10px;align-items:center"><div style="flex:1"><div style="font-size:13px;font-weight:600">📍 ${esc(name)}</div><div style="font-size:11px;color:var(--text4)">${+l.qty} available here</div></div><input class="form-input" id="is-pull-${l.locationId}" type="number" min="0" max="${+l.qty}" placeholder="0" style="width:90px;text-align:center" oninput="updateInjSupplyPullTotal(${ctx.qty})"></div>` }).join('')}
        </div>
        <div id="is-pull-total-hint" style="font-size:12px;color:var(--text3);padding:8px;background:var(--bg3);border-radius:var(--r2)">Choose amounts totaling ${ctx.qty}</div>
      </div>
      <div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="confirmInjSupplyPull()">Remove ${ctx.qty} EA</button></div>
    </div>`
  }

  // ── SKU Import Results modal ──
  else if (S.modal === 'skuImportResults') {
    content = `
    <div class="modal" style="width:min(500px,calc(100vw - 32px));max-height:80vh;overflow-y:auto">
      <div class="modal-hdr"><h3>SKU Import Results</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body">
        <div style="font-weight:600;margin-bottom:10px">${esc(d.summary)}</div>
        <div style="font-size:12px;display:flex;flex-direction:column;gap:2px">
          ${(d.results||[]).map(r => `<div style="padding:3px 0;border-bottom:1px solid var(--border)">${esc(r)}</div>`).join('')}
        </div>
      </div>
      <div class="modal-ftr"><button class="btn btn-primary" onclick="closeModal()">Done</button></div>
    </div>`
  }

  // ── Blend modals ──
  else if (S.modal === 'addBlend' || S.modal === 'editBlend') {
    const isEdit = S.modal === 'editBlend'
    const blend = isEdit ? S.blends.find(b => b.id === d.blendId) : null
    const components = blend?.components || []
    content = `
    <div class="modal" style="width:min(520px,calc(100vw - 32px));max-height:90vh;overflow-y:auto">
      <div class="modal-hdr"><h3>${isEdit ? 'Edit' : 'New'} Blend</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body">
        <div class="form-group"><label class="form-label">Blend Name *</label><input class="form-input" id="f-blend-name" placeholder="e.g. Semax/Selank PM Nasal" value="${esc(blend?.name||'')}"></div>

        <div class="form-group">
          <label class="form-label">Components</label>
          <div id="blend-comp-rows" style="display:flex;flex-direction:column;gap:8px">
            ${(components.length ? components : [{}]).map((c, i) => `
            <div class="blend-comp-row" style="display:grid;grid-template-columns:2fr 1fr auto;gap:6px;align-items:center">
              <select class="form-input bc-peptide" style="font-size:12px" onchange="const nx=this.parentElement.querySelector('.bc-name-wrap');if(nx)nx.remove();if(!this.value){const d=document.createElement('div');d.className='bc-name-wrap';d.innerHTML='<input class=\\'form-input bc-name\\' style=\\'font-size:12px\\' placeholder=\\'Custom name\\' value=\\'\\'>';this.after(d)}">
                <option value="">— Custom —</option>
                ${[...S.peptides].sort((a,b)=>a.name.localeCompare(b.name)).map(p => `<option value="${p.id}" ${c.peptideId===p.id?'selected':''}>${esc(p.name)}</option>`).join('')}
              </select>
              ${!c.peptideId && c.peptideName ? `<div class="bc-name-wrap"><input class="form-input bc-name" style="font-size:12px" placeholder="Custom name" value="${esc(c.peptideName)}"></div>` : ''}
              <div style="display:flex;gap:4px">
                <input class="form-input bc-amount" type="number" step="0.01" placeholder="Amount" style="font-size:12px;flex:1" value="${c.amountMg||''}">
                <select class="form-input bc-unit" style="font-size:12px;width:65px">
                  ${['mg','mcg','IU'].map(u => `<option ${(c.amountUnit||'mg')===u?'selected':''}>${u}</option>`).join('')}
                </select>
              </div>
              ${components.length > 1 || i > 0 ? `<button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="this.closest('.blend-comp-row').remove()">✕</button>` : '<div></div>'}
            </div>`).join('')}
          </div>
          <button class="btn btn-ghost btn-xs" style="margin-top:6px" onclick="addBlendComponentRow()">+ Add Component</button>
        </div>

        <div class="form-row">
          <div class="form-group" style="flex:1">
            <label class="form-label">Diluent Type</label>
            <select class="form-input" id="f-blend-diluent">
              ${['BAC Water','Sodium Chloride','Sterile Water','Saline'].map(t => `<option ${(blend?.diluentType||'BAC Water')===t?'selected':''}>${t}</option>`).join('')}
            </select>
          </div>
          <div class="form-group" style="flex:1">
            <label class="form-label">Diluent Volume (mL)</label>
            <input class="form-input" type="number" step="0.1" id="f-blend-diluent-ml" value="${blend?.diluentMl||3}">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Dose Volume (mL per dose)</label>
          <input class="form-input" type="number" step="0.01" id="f-blend-dose-vol" placeholder="e.g. 0.10" value="${blend?.doseVolumeMl||0.1}">
          <div style="font-size:11px;color:var(--text4);margin-top:4px">For nasal spray: ~0.10mL per spray. For injection: typical 0.05–0.50mL</div>
        </div>

        <div class="form-group"><label class="form-label">Notes</label><textarea class="form-input" id="f-blend-notes" rows="2" placeholder="Reconstitution notes, timing, storage...">${esc(blend?.notes||'')}</textarea></div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditBlend('${d.blendId}')` : 'saveAddBlend()'}">${isEdit ? 'Save' : 'Create Blend'}</button>
      </div>
    </div>`
  }

  // ── Cycle Link modal ──
  else if (S.modal === 'cycleLink') {
    const compound = d.compounds[d.unlinkedIdx]
    const remaining = d.compounds.filter((c,i) => i >= d.unlinkedIdx && c.linkedPeptideIds.length === 0).length
    content = `
    <div class="modal" style="width:min(460px,calc(100vw - 32px));max-height:90vh;overflow-y:auto">
      <div class="modal-hdr"><h3>Link Compound to Peptides</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body">
        <div style="background:var(--blueL);border-radius:var(--r2);padding:10px 14px;font-size:13px;color:var(--blue2);margin-bottom:12px">
          <strong>${esc(compound.name)}</strong> couldn't be auto-matched. Select the peptide(s) it corresponds to, or skip to leave unlinked.
          <div style="font-size:11px;margin-top:4px;color:var(--text4)">${remaining} compound${remaining!==1?'s':''} remaining</div>
        </div>
        <div style="display:flex;flex-direction:column;gap:6px;max-height:300px;overflow-y:auto">
          ${[...S.peptides].sort((a,b) => a.name.localeCompare(b.name)).map(p => `
          <label style="font-size:13px;display:flex;align-items:center;gap:8px;cursor:pointer;padding:4px">
            <input type="checkbox" class="cycle-link-cb" value="${p.id}"> ${esc(p.name)}
          </label>`).join('')}
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="saveCycleLinkAndContinue()">Skip (No Link)</button>
        <button class="btn btn-primary" onclick="saveCycleLinkAndContinue()">Link & Continue</button>
      </div>
    </div>`
  }

  // ── Vendor modals ──
  else if (S.modal === 'addVendor' || S.modal === 'editVendor') {
    const isEdit = S.modal === 'editVendor'
    const v = isEdit ? getVendor(d.vendorId) : null
    // Migrate legacy website to links
    const links = v?.links?.length ? v.links : (v?.website ? [{label:'Website',url:v.website}] : [{label:'',url:''}])
    content = `
    <div class="modal" style="width:min(480px,calc(100vw - 32px));max-height:90vh;overflow-y:auto">
      <div class="modal-hdr"><h3>${isEdit ? 'Edit' : 'Add'} Vendor</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body">
        <div class="form-group"><label class="form-label">Vendor Name *</label><input class="form-input" id="f-vend-name" value="${esc(v?.name||'')}"></div>
        <div class="form-group">
          <label class="form-label">Links</label>
          <div id="vend-links-rows" style="display:flex;flex-direction:column;gap:6px">
            ${links.map((l, i) => `<div class="form-row" style="gap:6px;align-items:center">
              <input class="form-input" id="f-vend-link-label-${i}" placeholder="Description (e.g. Main Site)" style="flex:1" value="${esc(l.label||'')}">
              <input class="form-input" id="f-vend-link-url-${i}" placeholder="https://..." style="flex:1.5" value="${esc(l.url||'')}">
              ${links.length > 1 ? `<button class="btn btn-ghost btn-xs" style="color:var(--red);flex-shrink:0" onclick="this.closest('.form-row').remove()">✕</button>` : ''}
            </div>`).join('')}
          </div>
          <button class="btn btn-ghost btn-xs" style="margin-top:6px" onclick="addVendorLinkRow()">+ Add Link</button>
        </div>
        <div class="form-row">
          <div class="form-group" style="flex:1"><label class="form-label">Email</label><input class="form-input" id="f-vend-email" placeholder="" value="${esc(v?.email||'')}"></div>
          <div class="form-group" style="flex:1"><label class="form-label">Telegram</label><input class="form-input" id="f-vend-telegram" placeholder="@handle or link" value="${esc(v?.telegram||'')}"></div>
        </div>
        <div class="form-row">
          <div class="form-group" style="flex:1"><label class="form-label">Discord</label><input class="form-input" id="f-vend-discord" placeholder="username or link" value="${esc(v?.discord||'')}"></div>
          <div class="form-group" style="flex:1"><label class="form-label">WhatsApp</label><input class="form-input" id="f-vend-whatsapp" placeholder="number or link" value="${esc(v?.whatsapp||'')}"></div>
        </div>
        <div class="form-group"><label class="form-label">Notes</label><textarea class="form-input" id="f-vend-notes" rows="2">${esc(v?.notes||'')}</textarea></div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditVendor('${d.vendorId}')` : 'saveAddVendor()'}">${isEdit?'Save':'Add'}</button>
      </div>
    </div>`
  }

  // ── Injection Supply modals ──
  else if (S.modal === 'addInjSupply' || S.modal === 'editInjSupply') {
    const isEdit = S.modal === 'editInjSupply'
    const s = isEdit ? getInjSupply(d.supplyId) : null
    content = `
    <div class="modal" style="width:min(420px,calc(100vw - 32px))">
      <div class="modal-hdr"><h3>${isEdit ? 'Edit' : 'Add'} Supply Type</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body">
        <div class="form-group"><label class="form-label">Name *</label><input class="form-input" id="f-is-name" placeholder="e.g. Pen Needles" value="${esc(s?.name||'')}"></div>
        <div class="form-group"><label class="form-label">Category</label><select class="form-input form-select" id="f-is-category" onchange="const ic=document.getElementById('f-is-cat-custom');if(this.value==='__custom__'){this.style.display='none';ic.style.display='block';ic.focus()}">
              <option value="">— Select —</option>
              ${injSupplyCategories().map(c => `<option value="${c}" ${s?.category===c?'selected':''}>${c}</option>`).join('')}</select></div>
        <div class="form-group"><label class="form-label">Description</label><input class="form-input" id="f-is-desc" value="${esc(s?.description||'')}"></div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Low Stock Threshold <span style="font-weight:400;color:var(--text4)">(0 = off)</span></label><input class="form-input" id="f-is-low" type="number" min="0" value="${s?.lowStockThreshold||0}"></div><div class="form-group" style="flex:1"><label class="form-label">Expiration Date</label><input class="form-input" id="f-is-exp" type="date" value="${esc(s?.expiryDate||'')}"></div></div>
        <label style="font-size:13px;display:flex;align-items:center;gap:8px;cursor:pointer;margin-top:4px"><input type="checkbox" id="f-is-syringe" ${s?.isSyringeNeedle?'checked':''}> This is a syringe or needle <span style="font-size:11px;color:var(--text4)">(adds gauge, needle length, units fields to SKUs)</span></label>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditInjSupply('${d.supplyId}')` : 'saveAddInjSupply()'}">${isEdit?'Save':'Add'}</button>
      </div>
    </div>`
  }
  else if (S.modal === 'addInjSku' || S.modal === 'editInjSku') {
    const isEdit = S.modal === 'editInjSku'
    const sk = isEdit ? getInjSku(d.supplyId, d.skuId) : null
    const parentSupply = getInjSupply(d.supplyId)
    const isSN = parentSupply?.isSyringeNeedle
    content = `
    <div class="modal" style="width:min(460px,calc(100vw - 32px));max-height:90vh;overflow-y:auto">
      <div class="modal-hdr"><h3>${isEdit ? 'Edit' : 'Add'} SKU</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body">
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Barcode</label><input class="form-input" id="f-isk-barcode" value="${esc(sk?.barcode||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">Vendor</label><input class="form-input" id="f-isk-vendor" value="${esc(sk?.vendor||'')}"></div></div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Lot Number</label><input class="form-input" id="f-isk-lot" value="${esc(sk?.lotNumber||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">${isSN ? 'Size/Gauge (legacy)' : 'Size/Gauge'}</label><input class="form-input" id="f-isk-size" placeholder="e.g. 29G ½&quot;" value="${esc(sk?.sizeGauge||'')}"></div></div>
        ${isSN ? `
        <div class="form-row">
          <div class="form-group" style="flex:1"><label class="form-label">Units / Volume</label><input class="form-input" id="f-isk-vol" placeholder="e.g. 1mL, 0.5mL" value="${esc(sk?.volume||'')}"></div>
          <div class="form-group" style="flex:1"><label class="form-label">Gauge</label><input class="form-input" id="f-isk-gauge" placeholder="e.g. 29g, 31g" value="${esc(sk?.gauge||'')}"></div>
          <div class="form-group" style="flex:1"><label class="form-label">Needle Length</label><input class="form-input" id="f-isk-needle-len" placeholder='e.g. 8mm, 1"' value="${esc(sk?.needleLength||'')}"></div>
        </div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Expiry Date</label><input class="form-input" id="f-isk-exp" type="date" value="${esc(sk?.expiryDate||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">Cost / EA</label><input class="form-input" id="f-isk-cost" placeholder="e.g. 0.15" value="${esc(sk?.costPerUnit||'')}"></div></div>` : `
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Volume</label><input class="form-input" id="f-isk-vol" placeholder="e.g. 1mL, 30mL" value="${esc(sk?.volume||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">Expiry Date</label><input class="form-input" id="f-isk-exp" type="date" value="${esc(sk?.expiryDate||'')}"></div></div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Cost / EA</label><input class="form-input" id="f-isk-cost" placeholder="e.g. 0.15" value="${esc(sk?.costPerUnit||'')}"></div><div class="form-group" style="flex:1"></div></div>`}
        <div class="form-group"><label class="form-label">Reorder URL</label><input class="form-input" id="f-isk-reorder" placeholder="https://..." value="${esc(sk?.reorderUrl||'')}"></div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">NIIMBOT Label</label><input class="form-input mono" id="f-isk-niimlabel" placeholder="⊙abc123⊙" value="${esc(sk?.niimLabel||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">NIIMBOT QR</label><input class="form-input mono" id="f-isk-niimqr" placeholder="⊙def456⊙" value="${esc(sk?.niimQR||'')}"></div></div>
        ${!isEdit ? `<div class="form-group"><label class="form-label">Initial Quantity</label><input class="form-input" id="f-isk-qty" type="number" min="0" value="0"></div>` : ''}
        <div class="form-group"><label class="form-label">Storage Locations</label>
          ${[0,1,2,3,4].map(i => {
            const loc = (sk?.locations||[])[i]
            const storageChoices = [...(S.storageLocations || [])].sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), undefined, { numeric:true, sensitivity:'base' }))
            return `<div class="form-row" style="margin-bottom:4px"><select class="form-input" id="f-isk-loc-id-${i}" style="flex:2"><option value="">— none —</option>${storageChoices.map(L => `<option value="${L.id}" ${loc?.locationId===L.id?'selected':''}>${esc(L.name)}</option>`).join('')}</select><input class="form-input" id="f-isk-loc-qty-${i}" type="number" min="0" placeholder="qty" style="flex:1" value="${loc?.qty||''}"></div>`
          }).join('')}
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditInjSku('${d.supplyId}','${d.skuId}')` : `saveAddInjSku('${d.supplyId}')`}">${isEdit?'Save':'Add'}</button>
      </div>
    </div>`
  }
  // ── Peptide Pen modals ──
  else if (S.modal === 'addPen' || S.modal === 'editPen') {
    const isEdit = S.modal === 'editPen'
    const pen = isEdit ? S.peptidePens.find(p => p.id === d.penId) : null
    content = `
    <div class="modal" style="width:min(440px,calc(100vw - 32px));max-height:90vh;overflow-y:auto">
      <div class="modal-hdr"><h3>${isEdit ? 'Edit' : 'Add'} Peptide Pen</h3><button class="btn-icon" onclick="closeModal()">${ICONS.close}</button></div>
      <div class="modal-body">
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Pen ID / SKU</label><input class="form-input mono" id="f-pen-tracking" placeholder="e.g. PEN-KLOW-01" value="${esc(pen?.penTrackingId||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">Pen Label Name</label><input class="form-input" id="f-pen-label" placeholder="e.g. Todd's KLOW Pen" value="${esc(pen?.labelName||'')}"></div></div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Brand</label><input class="form-input" id="f-pen-brand" value="${esc(pen?.brand||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">Model</label><input class="form-input" id="f-pen-model" value="${esc(pen?.model||'')}"></div></div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Pen Units</label><input class="form-input" id="f-pen-units" placeholder="e.g. 60 units" value="${esc(pen?.penUnits||'')}"></div><div class="form-group" style="flex:1;display:flex;align-items:flex-end;padding-bottom:4px"><label style="font-size:13px;display:flex;align-items:center;gap:8px;cursor:pointer"><input type="checkbox" id="f-pen-spacer" ${pen?.needsSpacer?'checked':''}> Needs Spacer/Adapter</label></div></div>
        <div class="form-row"><div class="form-group" style="flex:1"><label class="form-label">Color</label><input class="form-input" id="f-pen-color" placeholder="e.g. Blue, Red" value="${esc(pen?.color||'')}"></div><div class="form-group" style="flex:1"><label class="form-label">User</label><select class="form-input" id="f-pen-user"><option value="">— unassigned —</option>${(S.users||[]).filter(u=>u.active).map(u => `<option value="${u.id}" ${pen?.userId===u.id?'selected':''}>${esc(u.name)}</option>`).join('')}<option value="both" ${pen?.userId==='both'?'selected':''}>Both</option></select></div></div>
        ${isEdit ? `<div class="form-group"><label class="form-label">Status</label><select class="form-input" id="f-pen-status"><option value="active" ${pen?.status==='active'?'selected':''}>Active</option><option value="retired" ${pen?.status==='retired'?'selected':''}>Retired</option><option value="broken" ${pen?.status==='broken'?'selected':''}>Broken</option></select></div>` : ''}
        <div class="form-group"><label class="form-label">Linked Peptides</label>
          <div style="display:flex;flex-direction:column;gap:4px;max-height:160px;overflow-y:auto">
            ${[...S.peptides].sort((a,b) => (a.name||'').localeCompare(b.name||'')).map(p => `<label style="font-size:13px;display:flex;align-items:center;gap:6px;cursor:pointer"><input type="checkbox" class="pen-pep-cb" value="${p.id}" ${(pen?.linkedPeptideIds||[]).includes(p.id)?'checked':''}> ${esc(p.name)}</label>`).join('')}
          </div>
        </div>
        <div class="form-group"><label class="form-label">Notes</label><textarea class="form-input" id="f-pen-notes" rows="2">${esc(pen?.notes||'')}</textarea></div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditPen('${d.penId}')` : 'saveAddPen()'}">${isEdit?'Save':'Add'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'addLocation' || S.modal === 'editLocation') {
    const isEdit = S.modal === 'editLocation'
    const loc = isEdit ? S.storageLocations.find(l => l.id === d.locId) : null
    content = `
    <div class="modal" style="width:min(400px,calc(100vw - 32px))">
      <div class="modal-hdr">
        <h3>${isEdit ? 'Edit Location' : 'Add Location'}</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">Location Name *</label>
          <input class="form-input" id="f-loc-name" placeholder="e.g. Freezer A, Fridge 2, Cabinet B" value="${esc(loc?.name||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Total Capacity <span style="font-weight:400;color:var(--text4)">(slots/vials this location holds — 0 or blank = untracked)</span></label>
          <input class="form-input" id="f-loc-capacity" type="number" min="0" placeholder="e.g. 50" value="${esc(loc?.totalCapacity||'')}">
        </div>
      </div>
      <div class="modal-ftr">
        <button class="btn btn-secondary" onclick="closeModal()">Cancel</button>
        <button class="btn btn-primary" onclick="${isEdit ? `saveEditLocation('${d.locId}')` : 'saveAddLocation()'}">${isEdit ? 'Save' : 'Add Location'}</button>
      </div>
    </div>`
  }

  else if (S.modal === 'export') {
    const btnStyle = 'justify-content:flex-start;align-items:center;gap:10px;text-align:left'
    content = `
    <div class="modal" style="width:min(420px,calc(100vw - 32px))">
      <div class="modal-hdr">
        <h3>Export</h3>
        <button class="btn-icon" onclick="closeModal()">${ICONS.close}</button>
      </div>
      <div class="modal-body">
        <div style="display:flex;flex-direction:column;gap:10px">
          <button class="btn btn-secondary" style="${btnStyle}" onclick="exportCSV();closeModal()">${ICONS.export} <div><div style="font-weight:600">Peptide Export</div><div style="font-size:12px;color:var(--text3)">Peptide inventory as CSV</div></div></button>
          <button class="btn btn-secondary" style="${btnStyle}" onclick="exportSuppCSV();closeModal()">${ICONS.export} <div><div style="font-weight:600">Supplements Export</div><div style="font-size:12px;color:var(--text3)">Supplement inventory as CSV</div></div></button>
          <button class="btn btn-secondary" style="${btnStyle}" onclick="exportInjSuppliesCSV();closeModal()">${ICONS.export} <div><div style="font-weight:600">Supplies Export</div><div style="font-size:12px;color:var(--text3)">Injection supplies inventory as CSV</div></div></button>
          <button class="btn btn-secondary" style="${btnStyle}" onclick="exportVendorsCSV();closeModal()">${ICONS.export} <div><div style="font-weight:600">Vendors Export</div><div style="font-size:12px;color:var(--text3)">Vendor directory as CSV</div></div></button>
          <button class="btn btn-secondary" style="${btnStyle}" onclick="exportNotInStorageCSV();closeModal()">${ICONS.export} <div><div style="font-weight:600">Unlocated Supplies Report</div><div style="font-size:12px;color:var(--text3)">Supply SKUs not fully assigned to a supply location</div></div></button>
          <button class="btn btn-secondary" style="${btnStyle}" onclick="exportJSON();closeModal()">${ICONS.export} <div><div style="font-weight:600">JSON Backup</div><div style="font-size:12px;color:var(--text3)">All records and document links; physical files remain in the vault folder</div></div></button>
          <button class="btn btn-secondary" style="${btnStyle}" onclick="printReport();closeModal()">${ICONS.print} <div><div style="font-weight:600">Print Inventory Report</div><div style="font-size:12px;color:var(--text3)">Opens system print dialog</div></div></button>
        </div>
      </div>
    </div>`
  }


  // ── AI Protocol Assistant ──
  else if (S.modal === 'ai-assistant') {
    var md = S.modalData
    var modes = [{id:'protocol-review',l:'Protocol Review',d:'Review protocols for interactions'},{id:'lab-analysis',l:'Lab Analysis',d:'Analyze labs vs protocols'},{id:'optimization',l:'Optimization',d:'Suggest improvements'},{id:'custom',l:'Custom Query',d:'Ask anything'}]
    content = '<div class="modal modal-lg" style="width:800px;max-height:90vh">' +
      '<div class="modal-hdr"><h3 style="display:flex;align-items:center;gap:8px"><span style="background:var(--accent-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent">AI</span> Protocol Assistant</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div>' +
      '<div class="modal-body"><div style="display:grid;grid-template-columns:1fr 1fr;gap:8px">' +
        modes.map(function(m) { return '<button class="btn '+(md.mode===m.id?'btn-primary':'btn-secondary')+'" style="flex-direction:column;align-items:flex-start;padding:12px 14px;height:auto;text-align:left'+(md.mode===m.id?';background:var(--accent-gradient)':'')+'" onclick="S.modalData.mode=\''+m.id+'\';render()"><span style="font-weight:700">'+m.l+'</span><span style="font-size:11px;opacity:.7;font-weight:400">'+m.d+'</span></button>' }).join('') +
      '</div>' +
      (md.mode==='custom' ? '<div class="form-group" style="margin-top:12px"><label class="form-label">Your question</label><textarea class="form-input" rows="3" placeholder="Ask about your protocols..." onchange="S.modalData.query=this.value">' + esc(md.query) + '</textarea></div>' : '') +
      (md.response ? '<div style="background:var(--bg3);border:1px solid var(--border);border-radius:var(--r);padding:20px;max-height:400px;overflow-y:auto;font-size:13px;line-height:1.7;margin-top:12px">' + renderMarkdown(md.response) + '</div>' : '') +
      (md.loading ? '<div style="text-align:center;padding:32px;color:var(--text3)"><div style="font-size:24px;animation:pulse 1.5s infinite">\uD83E\uDDE0</div><div style="margin-top:8px">Analyzing\u2026</div></div>' : '') +
      (typeof hasAnthropicCredential==='function'&&!hasAnthropicCredential() ? '<div style="background:var(--yellowL);color:var(--yellowT);padding:12px;border-radius:var(--r2);font-size:13px;margin-top:12px">Configure AI in Settings first</div>' : '') +
      '</div><div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Close</button><button class="btn btn-primary" onclick="runAIAssistant()" '+(md.loading||(typeof hasAnthropicCredential==='function'&&!hasAnthropicCredential())?'disabled style="opacity:.5"':'')+'>'+(md.loading?'Analyzing\u2026':'Run Analysis')+'</button></div></div>'
  }

  // ── PDF Builder ──
  else if (S.modal === 'pdf-builder') {
    var md = S.modalData, activeUsers = (S.users||[]).filter(function(u){return u.active})
    var secs=[{k:'protocolSummary',l:'Active Protocols',i:'\uD83D\uDC89'},{k:'supplementSchedule',l:'Supplement Schedule',i:'\uD83D\uDC8A'},{k:'inventoryPeptides',l:'Peptide Inventory',i:'\uD83D\uDCE6'},{k:'inventorySupplements',l:'Supplement Inventory',i:'\uD83E\uDDF4'},{k:'inventorySupplies',l:'Supply Inventory',i:'\uD83E\uDE79'},{k:'injectionLog',l:'Injection Log',i:'\uD83D\uDCCB'},{k:'labResults',l:'Lab Results',i:'\uD83D\uDD2C'},{k:'vendorDirectory',l:'Vendor Directory',i:'\uD83C\uDFEA'}]
    content = '<div class="modal modal-lg" style="width:820px;max-height:90vh">' +
      '<div class="modal-hdr"><h3>PDF Document Builder</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div>' +
      '<div class="modal-body">' +
        '<div class="form-group" style="margin-bottom:8px"><label class="form-label">Document Title</label><input class="form-input" value="' + esc(md.title) + '" onchange="S.modalData.title=this.value"></div>' +
        '<div class="form-row" style="grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:12px">' +
          '<div class="form-group"><label class="form-label">From</label><input class="form-input" type="date" value="' + md.dateStart + '" onchange="S.modalData.dateStart=this.value"></div>' +
          '<div class="form-group"><label class="form-label">To</label><input class="form-input" type="date" value="' + md.dateEnd + '" onchange="S.modalData.dateEnd=this.value"></div>' +
          '<div class="form-group"><label class="form-label">User</label><select class="form-input form-select" onchange="S.modalData.userId=this.value">' + activeUsers.map(function(u){return '<option value="'+u.id+'"'+(md.userId===u.id?' selected':'')+'>'+esc(u.name)+'</option>'}).join('') + '</select></div>' +
        '</div>' +
        '<label class="form-label" style="margin-bottom:6px">Include Sections</label>' +
        '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px">' +
          secs.map(function(s){return '<label style="display:flex;align-items:center;gap:10px;padding:10px 14px;background:var(--bg3);border-radius:var(--r2);cursor:pointer;border:1px solid '+(md.sections[s.k]?'var(--accent)':'var(--border)')+';transition:all .15s"><input type="checkbox" '+(md.sections[s.k]?'checked':'')+' onchange="S.modalData.sections.'+s.k+'=this.checked;render()" style="width:16px;height:16px;accent-color:var(--accent)"><span style="font-size:15px">'+s.i+'</span><span style="font-size:13px;font-weight:600">'+s.l+'</span></label>'}).join('') +
        '</div>' +
        '<div style="display:flex;gap:16px;margin-top:10px">' +
          '<label class="toggle-wrap" onclick="S.modalData.includeHeader=!S.modalData.includeHeader;render()"><div class="toggle '+(md.includeHeader?'on':'')+'"></div><span style="font-size:13px;color:var(--text2)">Branded header</span></label>' +
          '<label class="toggle-wrap" onclick="S.modalData.includeFooter=!S.modalData.includeFooter;render()"><div class="toggle '+(md.includeFooter?'on':'')+'"></div><span style="font-size:13px;color:var(--text2)">Footer</span></label>' +
        '</div>' +
      '</div>' +
      '<div class="modal-ftr">' +
        '<div style="display:flex;gap:6px;margin-right:auto">' +
          '<button class="btn btn-ghost btn-xs" onclick="saveReportPreset()">Save Preset</button>' +
          ((S.reportPresets||[]).length > 0 ? '<select class="form-input" style="width:auto;font-size:11px" onchange="loadReportPreset(this.value)"><option value="">Load Preset\u2026</option>' + (S.reportPresets||[]).map(function(rp){return '<option value="'+rp.id+'">'+esc(rp.name)+'</option>'}).join('') + '</select>' : '') +
        '</div>' +
        '<button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="printPDFBuilder()">' + ICONS.print + ' Generate PDF</button></div></div>'
  }

  // ── Shopping List ──
  else if (S.modal === 'shopping-list') {
    var items = S.modalData && S.modalData.items ? S.modalData.items : getShoppingList()
    var urgColors = { critical: 'var(--red)', urgent: 'var(--yellow)', soon: 'var(--text3)' }
    var urgLabels = { critical: 'OUT / CRITICAL', urgent: 'LOW \u2014 ORDER SOON', soon: 'RUNNING LOW' }
    content = '<div class="modal modal-lg" style="width:700px;max-height:85vh">' +
      '<div class="modal-hdr"><h3>Shopping List</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div>' +
      '<div class="modal-body" style="padding:16px 24px">' +
        (items.length === 0 ? '<div class="empty-state" style="padding:32px"><div class="empty-icon">\u2705</div><p>Everything is well-stocked</p></div>' :
        items.map(function(item) {
          return '<div style="display:flex;align-items:center;gap:14px;padding:12px 0;border-bottom:1px solid var(--border)">' +
            '<div style="width:8px;height:8px;border-radius:50%;background:' + (urgColors[item.urgency]||'var(--text4)') + ';flex-shrink:0"></div>' +
            '<div style="flex:1;min-width:0"><div style="font-weight:700;font-size:14px">' + esc(item.name) + '</div><div style="font-size:12px;color:var(--text3)"><span class="badge" style="font-size:10px;padding:1px 6px;background:var(--bg4);color:var(--text3)">' + item.type + '</span>' + (item.brand ? ' &middot; ' + esc(item.brand) : '') + '</div></div>' +
            '<div style="text-align:right;flex-shrink:0"><div style="font-size:12px;font-weight:700;color:' + (urgColors[item.urgency]||'var(--text3)') + '">' + (item.daysLeft != null && item.daysLeft !== Infinity ? item.daysLeft + ' days left' : (item.qty != null ? item.qty + ' left' : '')) + '</div><div style="font-size:10px;color:var(--text4);text-transform:uppercase;letter-spacing:.5px">' + (urgLabels[item.urgency]||'') + '</div></div>' +
            (item.reorderUrl ? '<a href="' + esc(item.reorderUrl) + '" target="_blank" class="btn btn-xs btn-primary" style="flex-shrink:0">Order</a>' : '') +
          '</div>'
        }).join('')) +
      '</div><div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Close</button></div></div>'
  }

  // ── Scan Log Injection ──
  else if (S.modal === 'scan-log-injection') {
    var md = S.modalData
    content = '<div class="modal" style="width:600px">' +
      '<div class="modal-hdr"><h3>Log Injection from Scan</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div>' +
      '<div class="modal-body">' +
        '<div style="font-size:var(--fs-lg);font-weight:var(--fw-bold);color:var(--accent);margin-bottom:4px">' + esc(md.peptideName) + '</div>' +
        '<div class="form-row form-row-2"><div class="form-group"><label class="form-label">Date</label><input class="form-input" type="date" value="' + md.date + '" onchange="S.modalData.date=this.value"></div><div class="form-group"><label class="form-label">Time</label><input class="form-input" type="time" value="' + md.time + '" onchange="S.modalData.time=this.value"></div></div>' +
        '<div class="form-row form-row-2"><div class="form-group"><label class="form-label">Dosage</label><input class="form-input" placeholder="e.g. 250mcg" value="' + esc(md.dosage) + '" onchange="S.modalData.dosage=this.value"></div><div class="form-group"><label class="form-label">Draw Units</label><input class="form-input" type="number" placeholder="e.g. 10" value="' + esc(md.drawUnits) + '" onchange="S.modalData.drawUnits=this.value"></div></div>' +
        '<div class="form-group"><label class="form-label">Injection Site</label><input class="form-input" placeholder="e.g. SubQ abdomen" value="' + esc(md.site) + '" onchange="S.modalData.site=this.value"></div>' +
      '</div>' +
      '<div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="saveScanInjection()">Log Injection</button></div></div>'
  }

  // ── Sync Conflict ──
  else if (S.modal === 'sync-conflict') {
    var conflicts = S.modalData && S.modalData.conflicts ? S.modalData.conflicts : []
    content = '<div class="modal modal-lg">' +
      '<div class="modal-hdr"><h3>\u26A0\uFE0F Sync Conflict Detected</h3></div>' +
      '<div class="modal-body"><p style="color:var(--text2);font-size:var(--fs-base);margin-bottom:12px">Changes were made on another device. Choose how to resolve:</p>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">' +
        '<div style="background:var(--bg3);border:1px solid var(--green);border-radius:var(--r2);padding:14px"><div style="font-size:var(--fs-sm);font-weight:var(--fw-bold);color:var(--greenT);margin-bottom:8px">This Device</div>' + conflicts.map(function(c){return '<div style="font-size:12px;padding:2px 0">'+c.key+': '+c.localCount+' records</div>'}).join('') + '</div>' +
        '<div style="background:var(--bg3);border:1px solid var(--blue);border-radius:var(--r2);padding:14px"><div style="font-size:var(--fs-sm);font-weight:var(--fw-bold);color:var(--blue2);margin-bottom:8px">Cloud</div>' + conflicts.map(function(c){return '<div style="font-size:12px;padding:2px 0">'+c.key+': '+c.cloudCount+' records'+(c.added?' (+'+c.added+' new)':'')+(c.modified?' ('+c.modified+' changed)':'')+'</div>'}).join('') + '</div>' +
      '</div></div>' +
      '<div class="modal-ftr" style="flex-wrap:wrap;gap:8px"><button class="btn btn-secondary" onclick="resolveConflict(\'local\')" style="flex:1">Keep Local</button><button class="btn btn-primary" onclick="resolveConflict(\'merge\')" style="flex:1;background:var(--green)">Merge Both</button><button class="btn btn-primary" onclick="resolveConflict(\'cloud\')" style="flex:1">Use Cloud</button></div></div>'
  }

  // ── ICS Export ──
  else if (S.modal === 'ics-export') {
    var md = S.modalData, activeUsers = (S.users||[]).filter(function(u){return u.active})
    content = '<div class="modal" style="width:600px">' +
      '<div class="modal-hdr"><h3>Calendar Export (.ics)</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div>' +
      '<div class="modal-body">' +
        '<div style="display:flex;flex-direction:column;gap:8px">' +
          '<button class="btn btn-secondary" style="justify-content:flex-start;padding:14px 16px" onclick="exportInjectionICS(S.modalData.dateStart,S.modalData.dateEnd,S.modalData.userId);closeModal()"><span style="font-size:18px">\uD83D\uDC89</span><div style="text-align:left"><div style="font-weight:700">Export Injection History</div><div style="font-size:12px;color:var(--text3)">Past injections as calendar events</div></div></button>' +
          '<button class="btn btn-secondary" style="justify-content:flex-start;padding:14px 16px" onclick="exportProtocolICS(S.modalData.userId);closeModal()"><span style="font-size:18px">\uD83D\uDCC5</span><div style="text-align:left"><div style="font-weight:700">Export Protocol Schedule</div><div style="font-size:12px;color:var(--text3)">Next 90 days of planned injections</div></div></button>' +
        '</div>' +
        '<div class="form-row form-row-3" style="margin-top:12px">' +
          '<div class="form-group"><label class="form-label">From</label><input class="form-input" type="date" value="' + md.dateStart + '" onchange="S.modalData.dateStart=this.value"></div>' +
          '<div class="form-group"><label class="form-label">To</label><input class="form-input" type="date" value="' + md.dateEnd + '" onchange="S.modalData.dateEnd=this.value"></div>' +
          '<div class="form-group"><label class="form-label">User</label><select class="form-input form-select" onchange="S.modalData.userId=this.value">' + activeUsers.map(function(u){return '<option value="'+u.id+'"'+(md.userId===u.id?' selected':'')+'>'+esc(u.name)+'</option>'}).join('') + '</select></div>' +
        '</div>' +
      '</div></div>'
  }


    
    if (S.modal === 'addCoa') content = renderCoaModal(false)
    if (S.modal === 'editCoa') content = renderCoaModal(true)
    if (S.modal === 'addLabMarkerDef') content = '<div class="modal"><div class="modal-hdr"><h3>Add Lab Marker</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div><div class="modal-body"><div class="form-group"><label>Canonical Name</label><input class="input" id="lmd-name" placeholder="e.g. IGF-1"></div><div class="form-group"><label>Default Unit</label><input class="input" id="lmd-unit" placeholder="e.g. ng/mL"></div><div class="form-group"><label>Aliases (comma-separated)</label><input class="input" id="lmd-aliases" placeholder="e.g. IGF1, IGF 1"></div><div class="form-group"><label>Category</label><input class="input" id="lmd-category" placeholder="e.g. GH Axis"></div></div><div class="row" style="gap:8px;margin-top:12px;justify-content:flex-end;padding:0 20px 16px"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="saveLabMarkerDef()">Add</button></div></div>'
    if (S.modal === 'aiExplain') content = '<div class="modal modal-lg"><div class="modal-hdr"><h3>\uD83E\uDD16 ' + esc((S.modalData||{}).title||'AI Explanation') + '</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div><div class="modal-body" style="max-height:60vh;overflow-y:auto"><div style="font-size:13px;line-height:1.7">' + renderMarkdown((S.modalData||{}).content||'') + '</div></div><div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Close</button></div></div>'
    if (S.modal === 'addSavedView') content = '<div class="modal"><div class="modal-hdr"><h3>Save Current View</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div><div class="modal-body"><div class="form-group"><label>View Name</label><input class="input" id="sv-name" placeholder="e.g. Expiring <90 Days"></div><div style="font-size:12px;color:var(--text3);margin-top:8px">Saves current tab (' + S.tab + ') as a named view.</div></div><div class="row" style="gap:8px;margin-top:12px;justify-content:flex-end;padding:0 20px 16px"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="saveSavedView()">Save</button></div></div>'
    if (S.modal === 'addProtocol') content = renderProtocolModal(false)
    if (S.modal === 'editProtocol') content = renderProtocolModal(true)
    if (S.modal === 'addScenario') content = renderScenarioModal(false)
    if (S.modal === 'editScenario') content = renderScenarioModal(true)
    if (S.modal === 'addReservation') content = renderReservationModal()
    if (S.modal === 'protocolVialPlan') content = renderProtocolVialPlanModal()
    if (S.modal === 'manualVialPicker') content = renderManualVialPickerModal()
    if (S.modal === 'protocolCommandDetail' && window.renderProtocolCommandDetailModal) content = window.renderProtocolCommandDetailModal()
    if (S.modal === 'protocolWizard') content = renderProtocolWizard()

return content ? `<div class="overlay ${['editProtocol','protocolCommandDetail','protocolVialPlan','manualVialPicker'].includes(S.modal) ? 'overlay-drawer' : ''}" onclick="handleOverlayClick(event)" role="dialog" aria-modal="true">${content}</div>` : ''
}


// ══════════════════════════════════════════════════════
// PROTOCOL / SCENARIO / RESERVATION MODALS (v6.1)
// ══════════════════════════════════════════════════════

function renderProtocolModal(isEdit) {
  var p = isEdit ? (S.protocols||[]).find(function(x){return x.id===S.modalData.protocolId}) || {} : {}
  var peptides = (S.peptides||[]).filter(function(x){return !x.archived})
  var weekdays = p.weekdays || []
  var phases = p.phases || []
  var breaks = p.breaks || []
  var dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
  var isExplicit = p.scheduleMode === 'explicit' && (p.explicitEntries || []).length > 0
  var explicitCount = (p.explicitEntries || []).length
  var firstExplicit = explicitCount ? p.explicitEntries[0].date : ''
  var lastExplicit = explicitCount ? p.explicitEntries[explicitCount - 1].date : ''

  var weekdayHtml = '<div id="proto-weekdays-wrap" style="' + ((p.frequency||'') === 'custom' && !isExplicit ? '' : 'display:none;') + 'margin:8px 0">' +
    '<label style="font-size:12px;color:var(--text3)">Select Days</label>' +
    '<div style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap">' +
    dayNames.map(function(name, i) {
      return '<label style="display:flex;align-items:center;gap:3px;font-size:12px;cursor:pointer">' +
        '<input type="checkbox" class="proto-weekday" value="' + i + '"' + (weekdays.indexOf(i) >= 0 ? ' checked' : '') + '> ' + name + '</label>'
    }).join('') + '</div></div>'

  var phaseHtml = phases.map(function(ph) {
    return '<div class="proto-phase-row" style="display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:6px;align-items:end;margin-bottom:6px">' +
      '<div class="form-group"><label style="font-size:11px">Name</label><input class="input" style="font-size:12px" data-phase-name value="' + esc(ph.name||'') + '"></div>' +
      '<div class="form-group"><label style="font-size:11px">Start Day</label><input class="input" style="font-size:12px" type="number" data-phase-start value="' + (ph.startDay||0) + '"></div>' +
      '<div class="form-group"><label style="font-size:11px">End Day</label><input class="input" style="font-size:12px" type="number" data-phase-end value="' + (ph.endDay||0) + '"></div>' +
      '<div class="form-group"><label style="font-size:11px">Dose</label><input class="input" style="font-size:12px" type="number" step="any" data-phase-dose value="' + (ph.doseAmount||'') + '"></div>' +
      '<div class="form-group"><label style="font-size:11px">Unit</label><select class="input" style="font-size:12px" data-phase-unit>' +
        ['mcg','mg','mL','IU','units','sprays','drops'].map(function(u){return '<option value="'+u+'" '+(u===(ph.doseUnit||p.doseUnit||'mcg')?'selected':'')+'>'+u+'</option>'}).join('') +
      '</select></div>' +
      '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.proto-phase-row\').remove()" style="color:var(--red);margin-bottom:6px">\u2715</button></div>'
  }).join('')

  var breakHtml = breaks.map(function(br) {
    return '<div class="proto-break-row" style="display:grid;grid-template-columns:1fr 1fr 2fr auto;gap:6px;align-items:end;margin-bottom:6px">' +
      '<div class="form-group"><label style="font-size:11px">Start</label><input class="input" style="font-size:12px" type="date" data-break-start value="' + esc(br.startDate||'') + '"></div>' +
      '<div class="form-group"><label style="font-size:11px">End</label><input class="input" style="font-size:12px" type="date" data-break-end value="' + esc(br.endDate||'') + '"></div>' +
      '<div class="form-group"><label style="font-size:11px">Reason</label><input class="input" style="font-size:12px" data-break-reason value="' + esc(br.reason||'') + '"></div>' +
      '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.proto-break-row\').remove()" style="color:var(--red);margin-bottom:6px">\u2715</button></div>'
  }).join('')

  var scheduleBlock = isExplicit ?
    '<div class="protocol-imported-schedule">' +
      '<strong>Imported Exact Schedule · ' + explicitCount + ' planned doses</strong>' +
      '<p>' + esc(firstExplicit) + ' → ' + esc(lastExplicit) + '. These dated entries came from Master Plan and remain authoritative. Editing this protocol will not replace them with weekday rules.</p>' +
    '</div>' : ''

  return '<div class="modal modal-lg protocol-editor" onclick="event.stopPropagation()">' +
    '<div class="modal-hdr"><h3>' + (isEdit ? 'Edit' : 'New') + ' Protocol</h3><button class="btn btn-ghost btn-xs" onclick="closeModal()" aria-label="Close">✕</button></div>' +
    '<div class="modal-body">' +
      scheduleBlock +
      '<div class="form-group"><label>Protocol Name</label><input class="input" id="proto-name" value="' + esc(p.name||'') + '" placeholder="e.g. BPC-157 Healing Cycle"></div>' +
      '<div class="form-group"><label>Peptide</label><select class="input" id="proto-peptide">' +
        '<option value="">\u2014 Select \u2014</option>' +
        peptides.map(function(px){return '<option value="'+px.id+'" '+(px.id===p.peptideId?'selected':'')+'>'+esc(px.name)+'</option>'}).join('') +
      '</select></div>' +
      '<div class="' + (isExplicit ? 'protocol-readonly-field' : '') + '" style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
        '<div class="form-group"><label>Start Date</label><input class="input" type="date" id="proto-start" value="' + esc(p.startDate||'') + '"' + (isExplicit?' disabled':'') + '></div>' +
        '<div class="form-group"><label>End Date</label><input class="input" type="date" id="proto-end" value="' + esc(p.endDate||'') + '"' + (isExplicit?' disabled':'') + '></div>' +
      '</div>' +
      '<div class="form-group ' + (isExplicit ? 'protocol-readonly-field' : '') + '"><label>Frequency</label><select class="input" id="proto-freq"' + (isExplicit?' disabled':' onchange="document.getElementById(\'proto-weekdays-wrap\').style.display=this.value===\'custom\'?\'block\':\'none\'"') + '>' +
        ['daily','eod','3x-week','weekly','biweekly','custom'].map(function(f){return '<option value="'+f+'" '+(f===(p.frequency||'daily')?'selected':'')+'>'+protocolFreqLabel(f)+'</option>'}).join('') +
      '</select></div>' +
      weekdayHtml +
      '<div class="' + (isExplicit ? 'protocol-readonly-field' : '') + '" style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
        '<div class="form-group"><label>Default Dose</label><input class="input" type="number" step="any" id="proto-dose" value="' + esc(p.doseAmount||'') + '"' + (isExplicit?' disabled':'') + '></div>' +
        '<div class="form-group"><label>Unit</label><select class="input" id="proto-unit"' + (isExplicit?' disabled':'') + '>' +
          ['mcg','mg','mL','IU','units','sprays','drops'].map(function(u){return '<option value="'+u+'" '+(u===(p.doseUnit||'mcg')?'selected':'')+'>'+u+'</option>'}).join('') +
        '</select></div>' +
      '</div>' +
      (!isExplicit ? '<div style="margin:16px 0;border-top:1px solid var(--border);padding-top:12px">' +
        '<div class="row" style="margin-bottom:8px;align-items:center"><span style="font-size:13px;font-weight:600">Dose Phases</span><div class="spacer"></div><button class="btn btn-ghost btn-xs" onclick="addProtoPhaseRow()">+ Add Phase</button></div>' +
        '<div style="font-size:11px;color:var(--text4);margin-bottom:8px">Optional. Define dose ramps by day number. Phase dose overrides the default.</div>' +
        '<div id="proto-phases">' + phaseHtml + '</div>' +
      '</div>' : '<div id="proto-phases" style="display:none">' + phaseHtml + '</div>') +
      (!isExplicit ? '<div style="margin:12px 0;border-top:1px solid var(--border);padding-top:12px">' +
        '<div class="row" style="margin-bottom:8px;align-items:center"><span style="font-size:13px;font-weight:600">Breaks</span><div class="spacer"></div><button class="btn btn-ghost btn-xs" onclick="addProtoBreakRow()">+ Add Break</button></div>' +
        '<div style="font-size:11px;color:var(--text4);margin-bottom:8px">Optional. No doses during break windows.</div>' +
        '<div id="proto-breaks">' + breakHtml + '</div>' +
      '</div>' : '<div id="proto-breaks" style="display:none">' + breakHtml + '</div>') +
      '<div class="form-group"><label>Lifecycle</label><select class="input" id="proto-status">' +
        '<option value="automatic" '+(p.status!=='paused'?'selected':'')+'>Automatic — Upcoming, Active, or Completed from schedule dates</option>' +
        '<option value="paused" '+(p.status==='paused'?'selected':'')+'>Paused — manual override</option>' +
      '</select><small style="display:block;margin-top:5px;color:var(--text4)">Resume Automatic to let the imported first and last scheduled dates control status.</small></div>' +
      '<div class="form-group"><label>Notes</label><textarea class="input" id="proto-notes" rows="3">' + esc(p.notes||'') + '</textarea></div>' +
    '</div>' +
    '<div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="saveProtocolFromModal(\'' + (p.id||'') + '\')">Save Protocol</button></div>' +
  '</div>'
}

function renderScenarioModal(isEdit) {
  var sc = isEdit ? (S.scenarios||[]).find(function(x){return x.id===S.modalData.scenarioId}) || {} : {}
  var protocols = (S.protocols||[])
  return '<div class="modal modal-lg" onclick="event.stopPropagation()"><div class="modal-body" style="max-width:600px">' +
    '<h2>' + (isEdit ? 'Edit' : 'New') + ' Scenario</h2>' +
    (isEdit ? '' : '<div class="form-group" style="margin:10px 0"><label>Base Protocol</label><select class="input" id="scen-base">' +
      '<option value="">— Select —</option>' +
      protocols.map(function(p){return '<option value="'+p.id+'">'+esc(p.name||p.peptideName||'Protocol')+'</option>'}).join('') +
    '</select></div>') +
    '<div class="form-group" style="margin:10px 0"><label>Scenario Name</label><input class="input" id="scen-name" value="' + esc(sc.name||'') + '" placeholder="e.g. Higher Dose Test"></div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
      '<div class="form-group"><label>Start Date</label><input class="input" type="date" id="scen-start" value="' + esc(sc.startDate||'') + '"></div>' +
      '<div class="form-group"><label>End Date</label><input class="input" type="date" id="scen-end" value="' + esc(sc.endDate||'') + '"></div>' +
    '</div>' +
    '<div class="form-group" style="margin:10px 0"><label>Frequency</label><select class="input" id="scen-freq">' +
      ['daily','eod','3x-week','weekly','biweekly','custom'].map(function(f){return '<option value="'+f+'" '+(f===(sc.frequency||'daily')?'selected':'')+'>'+protocolFreqLabel(f)+'</option>'}).join('') +
    '</select></div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
      '<div class="form-group"><label>Dose Amount</label><input class="input" type="number" step="any" id="scen-dose" value="' + esc(sc.doseAmount||'') + '"></div>' +
      '<div class="form-group"><label>Unit</label><select class="input" id="scen-unit">' +
      ['mcg','mg','mL','IU','units','sprays','drops'].map(function(u){return '<option value="'+u+'" '+(u===(sc.doseUnit||'mcg')?'selected':'')+'>'+u+'</option>'}).join('') +
      '</select></div>' +
    '</div>' +
    '<div class="form-group" style="margin:10px 0"><label>Notes</label><textarea class="input" id="scen-notes" rows="3">' + esc(sc.notes||'') + '</textarea></div>' +
    '<div class="row" style="gap:8px;margin-top:16px;justify-content:flex-end">' +
      '<button class="btn btn-secondary" onclick="closeModal()">Cancel</button>' +
      '<button class="btn btn-primary" onclick="saveScenarioFromModal(\'' + (sc.id||'') + '\')">Save Scenario</button>' +
    '</div>' +
  '</div></div>'
}

function refreshReservationSkuOptions() {
  var pep = (document.getElementById('res-peptide') || {}).value || ''
  var sel = document.getElementById('res-sku')
  if (!sel) return
  Array.from(sel.options).forEach(function(opt, idx) {
    if (idx === 0) { opt.hidden = false; return }
    opt.hidden = opt.getAttribute('data-peptide') !== pep
  })
  if (sel.selectedOptions && sel.selectedOptions[0] && sel.selectedOptions[0].hidden) sel.value = ''
}

function renderReservationModal() {
  var horizon = protocolPlanningHorizon()
  var protocols = (S.protocols||[]).filter(function(p){return (p.status==='active'||p.status==='upcoming')&&(!p.startDate||p.startDate<=horizon.end)&&(!p.endDate||p.endDate>=horizon.start)})
  return '<div class="modal" onclick="event.stopPropagation()"><div class="modal-body" style="max-width:620px"><h2>Reserve Inventory</h2><p style="font-size:13px;color:var(--text3);margin:6px 0 14px">Select the protocol you want to fill. You will then choose each vial and set its usage order.</p>' +
    (protocols.length ? '<div style="display:flex;flex-direction:column;gap:8px;max-height:420px;overflow-y:auto">' + protocols.map(function(p) {
      var peptide = (S.peptides||[]).find(function(x){return x.id===p.peptideId||x.name===p.peptideName})
      var need = protocolPlanningNeed(p,horizon)
      var needed = need ? need.amount : 0
      var needUnit = need ? need.unit : ''
      var plan = (S.inventoryReservations||[]).filter(function(r){return r.protocolId===p.id})
      var summary = protocolVialAssignmentSummary(p.id)
      return '<button class="btn btn-secondary" style="padding:12px;text-align:left;display:grid;grid-template-columns:1fr auto;gap:12px;align-items:center" onclick="openProtocolVialPlan(\''+p.id+'\')"><span><strong style="display:block">'+esc(p.name||p.peptideName||'Protocol')+'</strong><span style="font-size:11px;color:var(--text4)">'+esc(peptide&&peptide.name||p.peptideName||'Unlinked')+'</span></span><span style="font-size:12px;color:var(--text2)">'+summary.pickedCount+' picked / assigned · '+summary.waitingCount+' waiting to pick →</span></button>'
    }).join('') + '</div>' : '<div class="empty-state" style="padding:30px"><p>No active or draft protocols</p></div>') +
    '<div class="row" style="margin-top:16px;justify-content:flex-end"><button class="btn btn-secondary" onclick="closeModal()">Close</button></div></div></div>'
}

function vialPlanStrength(sku, unit) {
  return Number(skuStrengthForUnit(sku, unit)) || 0
}

function renderLegacyProtocolVialPlanModal() {
  var protocol = (S.protocols || []).find(function(p) { return p.id === S.modalData.protocolId })
  if (!protocol) return '<div class="modal"><div class="modal-body">Protocol not found.</div></div>'
  var peptide = (S.peptides || []).find(function(p) { return p.id === protocol.peptideId || p.name === protocol.peptideName })
  var plan = S.modalData.vialPlan || (S.modalData.vialPlan = [])
  var horizon = protocolPlanningHorizon()
  var need = protocolPlanningNeed(protocol,horizon)
  var needUnit = need ? need.unit : ''
  var neededMg = need ? need.amount : 0
  var choices = peptide ? (peptide.skus || []).filter(function(sku) { return skuQty(sku) > 0 }) : []
  var pens = (S.peptidePens || []).filter(function(pen) { return pen.status !== 'broken' && (!peptide || !(pen.linkedPeptideIds||[]).length || (pen.linkedPeptideIds||[]).includes(peptide.id)) })
  var previewRows = plan.map(function(step,index){return { peptideId:peptide&&peptide.id||'', protocolId:protocol.id, skuId:step.skuId, qty:1, sequence:index+1, workflowStatus:'upcoming' }})
  assignPickingLocationsToPlanRows(previewRows, protocol.id)
  var previewGroup = 0
  var rows = plan.map(function(step, index) {
    if (index === 0 || !step.combineWithPrevious) previewGroup++
    var sku = choices.find(function(s) { return s.id === step.skuId }) || ((peptide && peptide.skus) || []).find(function(s) { return s.id === step.skuId })
    var strength = vialPlanStrength(sku, needUnit)
    var groupStart = index
    while (groupStart > 0 && plan[groupStart].combineWithPrevious) groupStart--
    var running = plan.slice(groupStart, index + 1).reduce(function(total, item) {
      var itemSku = ((peptide && peptide.skus) || []).find(function(s) { return s.id === item.skuId })
      return total + vialPlanStrength(itemSku, needUnit)
    }, 0)
    var preview = previewRows[index] || {}
    return '<div style="display:grid;grid-template-columns:34px 1fr auto auto;gap:8px;align-items:center;padding:9px 0;border-bottom:1px solid var(--border2);' + (step.combineWithPrevious?'border-left:3px solid var(--purple);padding-left:7px':'') + '">' +
      '<div style="width:28px;height:28px;border-radius:50%;display:grid;place-items:center;background:var(--accent);color:var(--bg);font-weight:700">' + (index + 1) + '</div>' +
      '<div><div style="font-weight:600">' + esc(strength ? strength + ' ' + needUnit + ' vial' : 'Unassigned or incompatible vial') + (step.combineWithPrevious?' <span class="badge" style="font-size:9px;background:var(--purpleL);color:var(--purpleT)">same pen load</span>':'') + '</div><div style="font-size:11px;color:var(--text4)">' + esc(sku ? (sku.lotNumber || sku.barcode || sku.id) : 'Choose a replacement') + ' · Load ' + previewGroup + ' · ' + running + (needUnit?' '+needUnit:'') + ' filled</div><div style="font-size:11px;margin-top:4px;color:'+(preview.pickLocationCode?'var(--blue)':'var(--red)')+'"><strong>'+(preview.pickLocationCode?'Pick from '+esc(preview.pickLocationCode):'No mapped storage location')+'</strong>'+(preview.pickHolderType?' · '+esc(preview.pickHolderType):'')+'</div>' + (index>0?'<button class="btn btn-ghost btn-xs" style="padding:2px 0;margin-top:3px;color:var(--purpleT)" onclick="toggleProtocolVialCombination('+index+')">'+(step.combineWithPrevious?'Separate from previous vial':'Combine with previous vial')+'</button>':'') + '</div>' +
      '<div style="display:flex;gap:2px"><button class="btn btn-ghost btn-xs" onclick="moveProtocolVialPlanStep(' + index + ',-1)" ' + (index === 0 ? 'disabled' : '') + '>↑</button><button class="btn btn-ghost btn-xs" onclick="moveProtocolVialPlanStep(' + index + ',1)" ' + (index === plan.length - 1 ? 'disabled' : '') + '>↓</button></div>' +
      '<button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="removeProtocolVialPlanStep(' + index + ')">✕</button>' +
    '</div>'
  }).join('')
  var filledMg = plan.reduce(function(total, step) {
    var sku = ((peptide && peptide.skus) || []).find(function(s) { return s.id === step.skuId })
    return total + vialPlanStrength(sku, needUnit)
  }, 0)
  var remainingMg = Math.max(0, neededMg - filledMg)
  var excessMg = Math.max(0, filledMg - neededMg)
  var fillPct = neededMg > 0 ? Math.min(100, filledMg / neededMg * 100) : 0
  var loadGroups = []
  var currentLoad = null
  plan.forEach(function(step, index) {
    if (index === 0 || !step.combineWithPrevious) {
      currentLoad = { number:loadGroups.length + 1, steps:[], totalMg:0, expectedInjections:Number(step.expectedInjections)||0 }
      loadGroups.push(currentLoad)
    }
    var loadSku = ((peptide && peptide.skus) || []).find(function(s) { return s.id === step.skuId })
    currentLoad.steps.push({ step:step, sku:loadSku, strength:vialPlanStrength(loadSku, needUnit) })
    currentLoad.totalMg += vialPlanStrength(loadSku, needUnit)
    if (!currentLoad.expectedInjections && Number(step.expectedInjections)>0) currentLoad.expectedInjections=Number(step.expectedInjections)
  })
  var loadSummary = loadGroups.map(function(load) {
    return '<div class="card" style="padding:11px;margin-top:8px;border-left:3px solid var(--purple)"><div style="display:flex;gap:12px;align-items:center;flex-wrap:wrap"><div style="flex:1;min-width:180px"><strong>Load ' + load.number + ' · ' + load.totalMg + ' ' + needUnit + ' combined</strong><div style="font-size:11px;color:var(--text4);margin-top:3px">' + load.steps.map(function(item){return (item.strength||'?')+' '+needUnit}).join(' + ') + ' · ' + load.steps.length + ' vial' + (load.steps.length===1?'':'s') + '</div></div><label style="font-size:11px;font-weight:600">Expected injections<input class="input" type="number" min="1" step="1" inputmode="numeric" style="width:130px;margin-top:4px" placeholder="e.g. 20" value="' + (load.expectedInjections||'') + '" onchange="setProtocolVialPlanExpectedInjections(' + load.number + ',this.value)"></label></div></div>'
  }).join('')
  return '<div class="modal protocol-vial-drawer" onclick="event.stopPropagation()"><div class="modal-body" style="max-width:620px">' +
    '<h2>Shop for Vials</h2><div style="font-size:13px;color:var(--text3);margin-bottom:14px">' + esc(protocol.name || protocol.peptideName || 'Protocol') + ' · choose the vials in the order you plan to use them</div>' +
    '<div class="card" style="padding:14px;margin-bottom:14px"><div style="display:flex;justify-content:space-between;align-items:baseline"><strong style="font-size:18px">' + (need?neededMg+' '+needUnit+' needed':'Planning amount unavailable') + '</strong><span style="font-size:13px;color:' + (remainingMg ? 'var(--amber)' : 'var(--green)') + '">' + filledMg + (needUnit?' '+needUnit:'') + ' assigned</span></div>' +
      '<div style="height:10px;background:var(--bg3);border-radius:8px;overflow:hidden;margin:10px 0 6px"><div style="height:100%;width:' + fillPct + '%;background:' + (remainingMg ? 'var(--amber)' : 'var(--green)') + '"></div></div>' +
      '<div style="font-size:12px;color:' + (remainingMg ? 'var(--amber)' : excessMg ? 'var(--blue)' : 'var(--green)') + '">' + (remainingMg ? remainingMg + ' ' + needUnit + ' remaining' : excessMg ? 'Covered with ' + excessMg + ' ' + needUnit + ' left over' : need ? 'Requirement filled exactly' : 'Set compatible protocol and vial units to calculate') + '</div></div>' +
    (!peptide ? '<div style="color:var(--red);margin-bottom:12px">This protocol must be linked to a peptide first.</div>' : '') +
    '<div class="form-group" style="margin-bottom:10px"><label style="font-size:12px;font-weight:600">Pen for these loads <span style="font-weight:400;color:var(--text4)">(optional)</span></label><select class="input" onchange="setProtocolVialPlanPen(this.value)"><option value="">No pen selected</option>' + pens.map(function(pen){return '<option value="'+pen.id+'" '+(S.modalData.penId===pen.id?'selected':'')+'>'+esc(pen.labelName||pen.model||pen.brand||'Pen')+'</option>'}).join('') + '</select></div>' +
    '<div style="display:flex;gap:8px;margin-bottom:8px;flex-wrap:wrap"><select class="input" id="vial-plan-sku" style="flex:1;min-width:230px"><option value="">Choose a vial to add…</option>' + choices.map(function(sku) { var strength = vialPlanStrength(sku, needUnit); return '<option value="' + sku.id + '" ' + (!strength?'disabled':'') + '>' + esc((strength ? strength + ' ' + needUnit : formatVialStrength(sku) + ' (unit mismatch)') + ' · ' + (sku.lotNumber || sku.barcode || sku.id) + ' · ' + skuQty(sku) + ' on hand') + '</option>' }).join('') + '</select><button class="btn btn-secondary" onclick="addProtocolVialPlanStep(false)">' + (plan.length?'Start Next Load':'Add First Vial') + '</button>' + (plan.length?'<button class="btn btn-primary" onclick="addProtocolVialPlanStep(true)">+ Add to Load ' + loadGroups.length + '</button>':'') + '</div>' +
    '<div style="max-height:300px;overflow-y:auto">' + (rows || '<div style="padding:24px;text-align:center;color:var(--text4)">No vials assigned yet. Add them in the order they will be used.</div>') + '</div>' +
    (loadSummary ? '<div style="margin-top:12px"><div style="font-size:12px;font-weight:700">Combined preparations</div>' + loadSummary + '</div>' : '') +
    '<div class="row" style="gap:8px;margin-top:18px;justify-content:flex-end"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="saveProtocolVialPlanFromModal()">Save Shopping List</button></div>' +
  '</div></div>'
}

function renderProtocolVialPlanModal() {
  var protocol = (S.protocols || []).find(function(p) { return p.id === S.modalData.protocolId })
  if (!protocol) return '<div class="modal"><div class="modal-body">Protocol not found.</div></div>'
  var components = typeof protocolVialComponents === 'function' ? protocolVialComponents(protocol) : []
  var blendChoices = S.modalData.blendPeptideChoices || (S.modalData.blendPeptideChoices = {})
  var plan = S.modalData.vialPlan || (S.modalData.vialPlan = [])
  plan.forEach(function(step) {
    if (step.peptideId) return
    var owner = (S.peptides || []).find(function(peptide){ return (peptide.skus || []).some(function(sku){ return sku.id === step.skuId }) })
    step.peptideId = owner && owner.id || protocol.peptideId || ''
  })
  var previewRows = plan.map(function(step,index){return { peptideId:step.peptideId||protocol.peptideId||'', protocolId:protocol.id, skuId:step.skuId, qty:1, sequence:index+1, workflowStatus:'upcoming' }})
  assignPickingLocationsToPlanRows(previewRows, protocol.id)
  var selected = plan.map(function(step,index) {
    var peptide = (S.peptides || []).find(function(item){ return item.id === step.peptideId })
    var sku = ((peptide&&peptide.skus)||[]).find(function(item){return item.id===step.skuId})
    var preview = previewRows[index] || {}
    return '<div class="vial-choice-row"><i>'+(index+1)+'</i><span><b>'+esc(peptide&&peptide.name||'Peptide')+' · '+esc(formatVialStrength(sku)||'Vial')+'</b><small>'+esc(sku&&(sku.lotNumber||sku.barcode||sku.id)||'SKU unavailable')+'</small></span><span class="vial-choice-location '+(preview.pickLocationCode?'':'missing')+'"><b>'+(preview.pickLocationCode?'Pick from '+esc(preview.pickLocationCode):'No mapped location')+'</b><small>'+esc(preview.pickHolderType||'')+'</small></span><button class="btn btn-ghost btn-xs" onclick="removeProtocolVialPlanStep('+index+')">Remove</button></div>'
  }).join('')
  var peptideSections = components.map(function(component,index) {
    var options = component.options || []
    var selectedId = blendChoices[String(index)] || ''
    var plannedOption = options.find(function(option){ return plan.some(function(step){ return step.peptideId === option.id }) })
    var peptide = options.find(function(option){ return option.id === selectedId }) || plannedOption || (options.length === 1 ? options[0] : null)
    if (!options.length) return '<section class="blend-vial-section missing"><header><div><span>Peptide '+(index+1)+'</span><h3>'+esc(component.name||'Unmapped peptide')+'</h3></div><em>Needs peptide mapping</em></header><p>No inventory can be selected until this blend component is linked to a Peptide SKU.</p></section>'
    var versionPicker = options.length > 1 ? '<label class="blend-version-picker"><span>Version / inventory product</span><select class="input" onchange="setProtocolBlendComponentPeptide('+index+',this.value)"><option value="">Choose standard or N-Acetyl…</option>'+options.map(function(option){return '<option value="'+option.id+'" '+(peptide&&peptide.id===option.id?'selected':'')+'>'+esc(option.name)+'</option>'}).join('')+'</select><small>Select the exact product stored in inventory.</small></label>' : '<div class="blend-version-resolved"><span>Inventory product</span><b>'+esc(options[0].name)+'</b></div>'
    if (!peptide) return '<section class="blend-vial-section needs-version"><header><div><span>Peptide '+(index+1)+'</span><h3>'+esc(component.name)+'</h3></div><em>Choose version</em></header>'+versionPicker+'<p>Choose the exact version before selecting a vial.</p></section>'
    var choices = (peptide.skus || []).filter(function(sku){ return skuQty(sku) > 0 }).slice().sort(function(a,b){
      return String(formatVialStrength(a)+' '+(a.lotNumber||a.barcode||a.id||'')).localeCompare(String(formatVialStrength(b)+' '+(b.lotNumber||b.barcode||b.id||'')),undefined,{numeric:true,sensitivity:'base'})
    })
    var selectedCount = plan.filter(function(step){ return step.peptideId === peptide.id }).length
    return '<section class="blend-vial-section"><header><div><span>Peptide '+(index+1)+'</span><h3>'+esc(component.name)+'</h3></div><em>'+selectedCount+' selected</em></header>'+versionPicker+
      (choices.length ? '<div><select class="input" id="vial-plan-sku-'+esc(peptide.id)+'"><option value="">Choose a '+esc(peptide.name)+' vial / SKU…</option>'+choices.map(function(sku){return '<option value="'+sku.id+'">'+esc(formatVialStrength(sku)+' · '+(sku.lotNumber||sku.barcode||sku.id)+' · '+skuQty(sku)+' available')+'</option>'}).join('')+'</select><button class="btn btn-primary" onclick="addProtocolVialPlanStep(\''+peptide.id+'\')">Add '+esc(peptide.name)+'</button></div>' : '<p>No available '+esc(peptide.name)+' vials are currently in inventory.</p>')+
    '</section>'
  }).join('')
  return '<div class="modal protocol-vial-drawer simple-vial-picker" onclick="event.stopPropagation()"><div class="modal-body">' +
    '<div class="vial-picker-heading"><div><span>Starting '+esc(modalDateLabel(protocol.startDate))+'</span><h2>'+esc(protocol.name||protocol.peptideName||'Protocol')+'</h2><p>'+esc(components.length?components.map(function(item){return item.name}).join(' + '):(protocol.peptideName||'Peptide not linked'))+'</p></div><button class="btn-icon" onclick="closeModal()">'+ICONS.close+'</button></div>' +
    '<div class="vial-picker-note"><i>1</i><span><b>Choose vials separately for every peptide.</b><small>Choose only what you want to pull now. This does not fill the entire protocol; inventory changes only when you mark a vial Picked.</small></span></div>' +
    (!components.length ? '<div class="vial-picker-warning">This upcoming protocol is not linked to a peptide, so no matching SKUs can be shown.</div>' : '') +
    '<div class="blend-vial-sections">'+peptideSections+'</div>' +
    renderPickedProtocolVials(protocol.id) +
    '<section class="vial-picker-selected"><header><div><b>New vials for this shopping trip</b><span>'+plan.length+' vial'+(plan.length===1?'':'s')+'</span></div></header>'+(selected||'<div class="vial-picker-empty">No new vials selected for another shopping trip.</div>')+'</section>' +
    '<div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" onclick="saveProtocolVialPlanFromModal()">Build Shopping List</button></div>' +
  '</div></div>'
}

function renderManualVialPickerModal() {
  var activeProtocols = (S.protocols || []).filter(function(protocol){ return protocol.status === 'active' }).slice().sort(function(a,b){
    return String(a.name||a.peptideName||'').localeCompare(String(b.name||b.peptideName||''),undefined,{numeric:true,sensitivity:'base'})
  })
  var peptides = (S.peptides || []).filter(function(peptide){
    return !peptide.archived && (peptide.skus || []).some(function(sku){ return skuQty(sku) > 0 })
  }).slice().sort(function(a,b){ return String(a.name||'').localeCompare(String(b.name||''),undefined,{numeric:true,sensitivity:'base'}) })
  var peptide = peptides.find(function(item){ return item.id === S.modalData.peptideId })
  var choices = ((peptide && peptide.skus) || []).filter(function(sku){ return skuQty(sku) > 0 }).slice().sort(function(a,b){
    return String(formatVialStrength(a)+' '+(a.lotNumber||a.barcode||a.id||'')).localeCompare(String(formatVialStrength(b)+' '+(b.lotNumber||b.barcode||b.id||'')),undefined,{numeric:true,sensitivity:'base'})
  })
  var selectedSku = choices.find(function(item){ return item.id === S.modalData.skuId })
  var preview = selectedSku && peptide ? { peptideId:peptide.id, skuId:selectedSku.id, qty:1, workflowStatus:'upcoming' } : null
  if (preview) assignPickingLocationsToPlanRows([preview],'manual-preview')
  return '<div class="modal protocol-vial-drawer simple-vial-picker" onclick="event.stopPropagation()"><div class="modal-body">' +
    '<div class="vial-picker-heading"><div><span>Any time storage pull</span><h2>Add Vials</h2><p>For continuous protocols, restocking, or any one-time need.</p></div><button class="btn-icon" onclick="closeModal()">'+ICONS.close+'</button></div>' +
    '<div class="vial-picker-note"><i>1</i><span><b>Build the list now; remove inventory when picked.</b><small>Nothing is deducted until you press Picked on the Shopping Lists screen.</small></span></div>' +
    '<label class="vial-picker-select"><span>Optional protocol / reason</span><select class="input" onchange="setManualVialContext(this.value)"><option value="">General storage pull</option>'+activeProtocols.map(function(protocol){return '<option value="'+protocol.id+'" '+(S.modalData.contextProtocolId===protocol.id?'selected':'')+'>'+esc(protocol.name||protocol.peptideName||'Active protocol')+'</option>'}).join('')+'</select></label>' +
    '<label class="vial-picker-select"><span>Peptide</span><select class="input" id="manual-vial-peptide" onchange="setManualVialPeptide(this.value)"><option value="">Choose a peptide…</option>'+peptides.map(function(item){return '<option value="'+item.id+'" '+(S.modalData.peptideId===item.id?'selected':'')+'>'+esc(item.name)+'</option>'}).join('')+'</select></label>' +
    '<label class="vial-picker-select"><span>Vial / SKU</span><select class="input" id="manual-vial-sku" onchange="S.modalData.skuId=this.value;render()"><option value="">Choose a vial / SKU…</option>'+choices.map(function(sku){return '<option value="'+sku.id+'" '+(S.modalData.skuId===sku.id?'selected':'')+'>'+esc(formatVialStrength(sku)+' · '+(sku.lotNumber||sku.barcode||sku.id)+' · '+skuQty(sku)+' available')+'</option>'}).join('')+'</select></label>' +
    '<div class="manual-vial-row"><label><span>Quantity</span><input class="input" id="manual-vial-qty" type="number" min="1" max="'+(selectedSku?skuQty(selectedSku):1)+'" value="'+Math.max(1,Number(S.modalData.quantity)||1)+'"></label><div class="manual-vial-location"><span>First storage stop</span><b>'+(preview&&preview.pickLocationCode?esc(preview.pickLocationCode):selectedSku?'No mapped location yet':'Choose a vial')+'</b><small>'+esc(preview&&preview.pickHolderType||'')+'</small></div></div>' +
    '<div class="modal-ftr"><button class="btn btn-secondary" onclick="closeModal()">Cancel</button><button class="btn btn-primary" '+(!selectedSku?'disabled':'')+' onclick="saveManualVialsToShoppingList()">Add to Shopping List</button></div>' +
  '</div></div>'
}

// ══════════════════════════════════════════════════════
// COA MODAL (v6.3)
// ══════════════════════════════════════════════════════

function renderCoaModal(isEdit) {
  var coa = isEdit ? (S.coas||[]).find(function(c){return c.id===S.modalData.coaId}) || {} : {}
  var vendors = (S.vendors || [])
  var coaDocuments = (S.documents || []).filter(function(d) { return d.type === 'coa' })
  var preLinkedLotId = S.modalData.preLinkedLotId || ''

  // Build lot options from all peptide SKUs
  var lotOptions = []
  ;(S.peptides || []).forEach(function(p) {
    ;(p.skus || []).forEach(function(s) {
      lotOptions.push({
        skuId: s.id,
        lotNumber: s.lotNumber || '',
        peptideName: p.name,
        vendor: s.vendor || '',
        label: p.name + ' \u2014 ' + (s.lotNumber || s.id) + (s.vendor ? ' (' + s.vendor + ')' : '')
      })
    })
  })

  var existingLotIds = isEdit ? (coa.lotIds || []) : (preLinkedLotId ? [preLinkedLotId] : [])

  // Build existing result rows
  var resultRows = ''
  if (isEdit && coa.results) {
    resultRows = (coa.results || []).map(function(r) {
      return '<div class="coa-result-row" style="display:grid;grid-template-columns:2fr 1fr 1fr 2fr auto auto;gap:6px;align-items:end;margin-bottom:6px">' +
        '<div class="form-group"><label style="font-size:11px">Test Name</label><input class="input" style="font-size:12px" data-result-name value="' + esc(r.testName || '') + '"></div>' +
        '<div class="form-group"><label style="font-size:11px">Result</label><input class="input" style="font-size:12px" data-result-value value="' + esc(r.value || '') + '"></div>' +
        '<div class="form-group"><label style="font-size:11px">Unit</label><input class="input" style="font-size:12px" data-result-unit value="' + esc(r.unit || '') + '"></div>' +
        '<div class="form-group"><label style="font-size:11px">Specification</label><input class="input" style="font-size:12px" data-result-spec value="' + esc(r.specification || '') + '"></div>' +
        '<div class="form-group"><label style="font-size:11px">Pass</label><input type="checkbox" data-result-pass' + (r.pass !== false ? ' checked' : '') + ' style="margin-top:6px"></div>' +
        '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.coa-result-row\').remove()" style="color:var(--red);margin-bottom:6px">\u2715</button></div>'
    }).join('')
  }

  return '<div class="modal modal-lg">' +
    '<div class="modal-hdr"><h3>' + (isEdit ? 'Edit COA' : 'Add Certificate of Analysis') + '</h3><button class="btn-icon" onclick="closeModal()">' + ICONS.close + '</button></div>' +
    '<div class="modal-body" style="max-height:70vh;overflow-y:auto">' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">' +
        '<div class="form-group"><label>Report #</label><input class="input" id="coa-reportno" value="' + esc(coa.reportNo || '') + '" placeholder="e.g. RPT-2024-001"></div>' +
        '<div class="form-group"><label>Test Lab</label><input class="input" id="coa-testlab" value="' + esc(coa.testLab || '') + '" placeholder="e.g. Janoshik"></div>' +
        '<div class="form-group"><label>Test Date</label><input class="input" type="date" id="coa-testdate" value="' + esc(coa.testDate || '') + '"></div>' +
        '<div class="form-group"><label>Order ID</label><input class="input" id="coa-orderid" value="' + esc(coa.orderId || '') + '" placeholder="Optional order reference"></div>' +
      '</div>' +

      '<div class="form-group" style="margin-top:12px"><label>Vendor</label>' +
        '<select class="form-input" id="coa-vendor">' +
          '<option value="">\u2014 Select Vendor \u2014</option>' +
          vendors.map(function(v) {
            return '<option value="' + v.id + '"' + (coa.vendorId === v.id ? ' selected' : '') + '>' + esc(v.name) + '</option>'
          }).join('') +
        '</select>' +
      '</div>' +

      '<div class="form-group" style="margin-top:12px"><label>COA Document</label>' +
        '<select class="form-input" id="coa-document"><option value="">— No document linked —</option>' +
          coaDocuments.map(function(doc) { return '<option value="' + doc.id + '"' + (coa.documentId === doc.id ? ' selected' : '') + '>' + esc(doc.name || doc.originalName || 'COA document') + '</option>' }).join('') +
        '</select>' +
      '</div>' +

      // Lot multi-selector
      '<div class="form-group" style="margin-top:12px"><label>Linked Lots</label>' +
        '<div style="max-height:120px;overflow-y:auto;border:1px solid var(--border);border-radius:var(--r1);padding:6px">' +
          (lotOptions.length === 0 ? '<div style="font-size:12px;color:var(--text4);padding:4px">No lots available \u2014 add peptide SKUs first</div>' :
            lotOptions.map(function(lo) {
              var checked = existingLotIds.indexOf(lo.skuId) >= 0 || existingLotIds.indexOf(lo.lotNumber) >= 0
              return '<label style="display:flex;align-items:center;gap:6px;font-size:12px;padding:3px 0;cursor:pointer">' +
                '<input type="checkbox" class="coa-lot-check" value="' + lo.skuId + '"' + (checked ? ' checked' : '') + '> ' + esc(lo.label) +
              '</label>'
            }).join('')
          ) +
        '</div>' +
      '</div>' +

      // Test results
      '<div style="margin-top:14px">' +
        '<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px">' +
          '<label style="font-weight:600;font-size:13px">Test Results</label>' +
          '<button class="btn btn-secondary btn-xs" onclick="addCoaResultRow()">' + ICONS.plus + ' Add Row</button>' +
        '</div>' +
        '<div id="coa-results-container">' + resultRows + '</div>' +
      '</div>' +

      '<div class="form-group" style="margin-top:12px"><label>Notes</label><textarea class="input" id="coa-notes" rows="3" placeholder="Optional notes">' + esc(coa.notes || '') + '</textarea></div>' +
    '</div>' +
    '<div class="row" style="gap:8px;margin-top:16px;justify-content:flex-end;padding:0 20px 16px">' +
      '<button class="btn btn-secondary" onclick="closeModal()">Cancel</button>' +
      '<button class="btn btn-primary" onclick="saveCoaFromModal(' + (isEdit ? "'" + coa.id + "'" : '') + ')">' + (isEdit ? 'Save' : 'Add COA') + '</button>' +
    '</div>' +
  '</div>'
}

export {
  labMarkerRow,
  addLabMarkerRow,
  renderModal,
  renderProtocolModal,
  renderScenarioModal,
  renderReservationModal,
  renderProtocolVialPlanModal,
  renderManualVialPickerModal,
  renderCoaModal
}
